    (function() {
      var filterRoot = document.getElementById('HdColorFilter');
      if (!filterRoot) return;

      var collectionRoot = document.getElementById('Collection');
      var cardsContainer = document.getElementById('AjaxinateLoop');
      var paginationEl = document.getElementById('AjaxinatePagination');
      var filterSpinnerEl = document.getElementById('hd-filter-spinner');
      var filterSpinnerMessageEl = document.getElementById('hd-filter-spinner-message');
      var filterAnimTimer = null;
      var DEFAULT_FILTER_SPINNER_MESSAGE = 'Loading products...';
      var preloadProgressTotal = 0;
      var preloadProgressLoaded = 0;
      var preloadProgressFailed = 0;
      // Move spinner to <body> so position:fixed isn't broken by ancestor transforms
      if (filterSpinnerEl && filterSpinnerEl.parentNode !== document.body) {
        document.body.appendChild(filterSpinnerEl);
      }
      function setFilterSpinnerMessage(messageText) {
        if (!filterSpinnerMessageEl) return;
        var nextMessage = String(messageText || '').replace(/\s+/g, ' ').trim();
        if (!nextMessage) nextMessage = DEFAULT_FILTER_SPINNER_MESSAGE;
        filterSpinnerMessageEl.textContent = nextMessage;
      }
      function buildPreloadSpinnerMessage() {
        if (preloadProgressTotal <= 0) return 'Loading all products...';
        var pagesComplete = Math.min(preloadProgressTotal, preloadProgressLoaded + preloadProgressFailed);
        if (pagesComplete >= preloadProgressTotal) return 'Finalizing product order...';
        return 'Loading products ' + pagesComplete + ' / ' + preloadProgressTotal + '...';
      }
      function updatePreloadProgressMessage() {
        if (!filterSpinnerEl || !filterSpinnerEl.classList.contains('is-active')) return;
        setFilterSpinnerMessage(buildPreloadSpinnerMessage());
      }
      function showFilterSpinner(messageText) {
        if (!filterSpinnerEl || !cardsContainer) return;
        setFilterSpinnerMessage(messageText);
        var rect = cardsContainer.getBoundingClientRect();
        var vh = window.innerHeight || 600;
        var centerX = rect.left + rect.width / 2;
        var centerY = Math.max(120, Math.min(rect.top + Math.round(rect.height * 0.25), vh - 100));
        filterSpinnerEl.style.left = centerX + 'px';
        filterSpinnerEl.style.top  = centerY + 'px';
        filterSpinnerEl.style.transform = 'translate(-50%, -50%)';
        filterSpinnerEl.classList.add('is-active');
        filterSpinnerEl.setAttribute('aria-hidden', 'false');
      }
      function hideFilterSpinner() {
        if (!filterSpinnerEl) return;
        filterSpinnerEl.classList.remove('is-active');
        filterSpinnerEl.setAttribute('aria-hidden', 'true');
        setFilterSpinnerMessage(DEFAULT_FILTER_SPINNER_MESSAGE);
      }
      var swatchesEl = document.getElementById('HdColorFilterSwatches');
      var sizeOptionsEl = document.getElementById('HdSizeFilterOptions');
      var summaryEl = document.getElementById('HdColorFilterSummary');
      var searchInputEl = document.getElementById('HdColorFilterSearchInput');
      var searchClearEl = document.getElementById('HdColorFilterSearchClear');
      var utilityEl = filterRoot.querySelector('.hd-color-filter__utility');
      var resetEl = document.getElementById('HdColorFilterReset');
      var selectedCountEl = document.getElementById('HdColorFilterSelectedCount');
      var stockToggleEl = document.getElementById('HdStockToggle');
      var toggleEl = document.getElementById('HdColorFilterToggle');
      var filterBodyEl = document.getElementById('HdColorFilterBody');
      var emptyEl = document.getElementById('HdColorFilterEmpty');
      var sortSelect = document.getElementById('SortBy');
      var sortChoiceEls = Array.prototype.slice.call(document.querySelectorAll('.hd-sort-control__choice'));
      var sortControlEl = document.getElementById('HdSortControl');
      var searchPanelEl = document.getElementById('HdSearchPanel');
      var browsePanelEl = document.getElementById('HdBrowsePanel');
      var browseToggleEl = document.getElementById('HdBrowseToggle');
      var browseBodyEl = document.getElementById('HdBrowseBody');
      var mainControlsEl = document.getElementById('HdMainControls');
      var controlsSummaryEl = document.getElementById('HdControlsSummary');
      var drawerStackEl = document.getElementById('HdDrawerStack');
      var mainControlsSpacerEl = collectionRoot ? collectionRoot.querySelector('.hd-main-controls-spacer') : null;
      var stickyCartButtonEl = document.getElementById('HdStickyCartButton');
      var stickyCartCountEl = document.getElementById('HdStickyCartCount');
      var headerCartLinkEl = document.querySelector('.site-header__cart');
      var headerCartBubbleEl = document.getElementById('CartCount');
      var headerCartCountEl = headerCartBubbleEl ? (headerCartBubbleEl.querySelector('span:not(.icon__fallback-text)') || headerCartBubbleEl.querySelector('span')) : null;
      var cartCountRefreshTimer = null;
      var quickAddModalEl = document.getElementById('HdQuickAddModal');
      var quickAddDialogEl = document.getElementById('HdQuickAddDialog');
      var quickAddMountEl = document.getElementById('HdQuickAddMount');
      var quickAddStatusEl = document.getElementById('HdQuickAddStatus');
      var quickAddOpenProductEl = document.getElementById('HdQuickAddOpenProduct');
      var quickAddTitleEl = document.getElementById('HdQuickAddTitle');
      var quickAddTitleProductEl = document.getElementById('HdQuickAddTitleProduct');
      var quickAddLastFocusedEl = null;
      var quickAddProductCache = {};
      var quickAddCurrentToken = 0;
      var quickAddModalObserver = null;
      var quickAddEventsHooked = false;
      var quickAddOriginalMwOnEvent = null;
      var quickAddActiveProductId = '';
      var quickAddSyncInventoryOriginal = null;

      // Cart Drawer refs
      var cartDrawerEl = document.getElementById('HdCartDrawer');
      var cartDrawerPanelEl = document.getElementById('HdCartDrawerPanel');
      var cartDrawerBodyEl = document.getElementById('HdCartDrawerBody');
      var cartDrawerLoadingEl = document.getElementById('HdCartDrawerLoading');
      var cartDrawerEmptyEl = document.getElementById('HdCartDrawerEmpty');
      var cartDrawerItemsEl = document.getElementById('HdCartDrawerItems');
      var cartDrawerFooterEl = document.getElementById('HdCartDrawerFooter');
      var cartDrawerSubtotalEl = document.getElementById('HdCartDrawerSubtotal');
      var cartDrawerBadgeEl = document.getElementById('HdCartDrawerBadge');
      var cartDrawerCachedData = null;
      var quickAddGuidedObserver = null;
      var quickAddGuidedRenderTimer = null;
      var quickAddGuidedLastSignature = '';
      var quickAddNoOptionsTimer = null;
      var quickAddWarmupTimer = null;
      var quickAddWarmHandles = {};
      var quickAddWarmupRequested = false;
      if (!collectionRoot || !cardsContainer || !swatchesEl || !resetEl) return;

      var selectedColors = new Set();
      var selectedSizeKey = '';
      var cards = [];
      var visibleProductCount = 0;
      var nextPageUrl = '';
      var loadingNextPage = false;
      var loadingAllPagesPromise = null;
      var loadedPageUrls = {};
      var pageLoadRetryCounts = {};
      var MAX_PAGE_FETCH_RETRIES = 2;
      var preloadPromise = null;
      var updateTransitionTimer = null;
      var criteriaLoadTimer = null;
      var criteriaVersion = 0;
      var criteriaAutoContinueCount = 0;
      var MAX_CRITERIA_AUTO_CONTINUE_CYCLES = 120;
      var defaultSortValue = sortSelect ? (sortSelect.getAttribute('data-default-sortby') || '') : '';
      var collectionVersion = 0;
      var activeDrawerId = '';
      var drawerOpenScrollY = 0;
      var DRAWER_AUTO_HIDE_SCROLL_DELTA = 240;
      var DRAWER_AUTO_HIDE_MIN_OPEN_MS = 520;
      var DRAWER_AUTO_HIDE_SETTLE_MS = 180;
      var DRAWER_AUTO_HIDE_DIRECTION_MIN_DELTA = 10;
      var drawerAutoHideRaf = null;
      var drawerAutoHideTimer = null;
      var drawerAutoHideGraceTimer = null;
      var drawerOpenedAtMs = 0;
      var drawerLastScrollY = 0;
      var drawerAutoHideSawDownwardScroll = false;
      var searchQuery = '';
      var searchTerms = [];
      var searchQueryLabel = '';
      var stockFilterActive = false;
      var totalCollectionPages = Math.max(1, Number(parseInt(filterRoot.getAttribute('data-hd-total-pages') || '1', 10) || 1));
      var mobileControlsMedia = window.matchMedia('(max-width: 989px)');
      var connectionHint = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var networkTypeHint = connectionHint && connectionHint.effectiveType ? String(connectionHint.effectiveType) : '';
      var saveDataHint = Boolean(connectionHint && connectionHint.saveData);
      var downlinkHint = connectionHint && typeof connectionHint.downlink === 'number' ? Number(connectionHint.downlink) : 0;
      var deviceMemoryHint = typeof navigator.deviceMemory === 'number' ? Number(navigator.deviceMemory) : 0;
      var hardwareConcurrencyHint = typeof navigator.hardwareConcurrency === 'number' ? Number(navigator.hardwareConcurrency) : 0;
      var PRELOAD_PAGE_MAX_RETRIES = 2;
      var COLLECTION_FETCH_TIMEOUT_MS = mobileControlsMedia && mobileControlsMedia.matches ? 9500 : 12000;
      var colorCountsCache = null;
      var colorCountsCacheKey = '';
      var collectionStateKey = getCollectionStateKey(window.location.pathname);
      var collectionReturnIntentKey = collectionStateKey + ':return_intent';
      var COLLECTION_STATE_MAX_AGE_MS = 1000 * 60 * 90;
      var PREVIEW_QUERY_PARAMS = ['preview_theme_id', '_fd', 'pb'];
      var colorMetafieldPath = String(filterRoot.getAttribute('data-hd-color-metafield-path') || '').trim();
      var serverColorFilterParamName = '';
      var SERVER_STOCK_FILTER_PARAM_NAME = 'filter.v.availability';
      var serverColorFilterValuesByKey = {};
      var extractedColorKeysCache = Object.create(null);
      nextPageUrl = getNextPageUrlFromDocument(document);

      function resolvePreloadBatchSize() {
        var isMobileViewport = Boolean(mobileControlsMedia && mobileControlsMedia.matches);
        var isSlowNetwork = networkTypeHint.indexOf('2g') !== -1;
        var isModerateNetwork = networkTypeHint === '3g';

        if (saveDataHint || isSlowNetwork) return 1;
        if (isModerateNetwork) return isMobileViewport ? 1 : 2;

        if (isMobileViewport) {
          var lowEndMobile = (deviceMemoryHint && deviceMemoryHint <= 3) || (hardwareConcurrencyHint && hardwareConcurrencyHint <= 4);
          if (downlinkHint && downlinkHint < 1.6) return 1;
          if (lowEndMobile) return 2;
          if (downlinkHint && downlinkHint >= 8) return 4;
          return 3;
        }

        if (downlinkHint && downlinkHint < 2.5) return 2;
        return 4;
      }

      var BASE_COLOR_GROUPS = [
        { key: 'red', label: 'Red', swatch: '#d94343' },
        { key: 'pink', label: 'Pink', swatch: '#f28ab8' },
        { key: 'orange', label: 'Orange', swatch: '#f58b2a' },
        { key: 'yellow', label: 'Yellow', swatch: '#f0cd3e' },
        { key: 'green', label: 'Green', swatch: '#5db26c' },
        { key: 'blue', label: 'Blue', swatch: '#4f80e1' },
        { key: 'purple', label: 'Purple', swatch: '#8a66d9' },
        { key: 'brown', label: 'Brown', swatch: '#8d5a3d' },
        { key: 'white', label: 'White', swatch: '#ffffff' },
        { key: 'black', label: 'Black', swatch: '#1f1f1f' },
        { key: 'gray', label: 'Gray', swatch: '#8a929e' },
        { key: 'gold', label: 'Gold', swatch: '#c7a83f' },
        { key: 'multicolor', label: 'Multicolor', swatch: 'conic-gradient(#e85757, #f0cd3e, #50b56f, #4f80e1, #8a66d9, #e85757)' },
        { key: 'clear', label: 'Clear', swatch: 'linear-gradient(130deg, #f5f8fb, #dfe5ec)' },
        { key: 'glow', label: 'Glow', swatch: 'radial-gradient(circle, #fdf17f 0%, #f2a9ff 50%, #67d9ff 100%)' }
      ];

      var SWATCH_TEXT_BY_KEY = {
        yellow: '#2f1f45',
        white: '#2f1f45',
        clear: '#2f1f45',
        glow: '#2f1f45',
        pink: '#3d1f45',
        gold: '#2f1f45',
        multicolor: '#2f1f45'
      };

      var COLOR_ALIASES = {
        red: 'red',
        ruby: 'red',
        cherry: 'red',
        crimson: 'red',
        scarlet: 'red',
        burgundy: 'red',
        pink: 'pink',
        rose: 'pink',
        fuchsia: 'pink',
        magenta: 'pink',
        blush: 'pink',
        orange: 'orange',
        peach: 'orange',
        coral: 'orange',
        amber: 'orange',
        tangerine: 'orange',
        yellow: 'yellow',
        lemon: 'yellow',
        mustard: 'yellow',
        green: 'green',
        emerald: 'green',
        mint: 'green',
        sage: 'green',
        olive: 'green',
        hunter: 'green',
        blue: 'blue',
        aqua: 'blue',
        teal: 'blue',
        turquoise: 'blue',
        navy: 'blue',
        sky: 'blue',
        cobalt: 'blue',
        aquamarine: 'blue',
        purple: 'purple',
        violet: 'purple',
        lilac: 'purple',
        lavender: 'purple',
        amethyst: 'purple',
        plum: 'purple',
        brown: 'brown',
        tan: 'brown',
        mocha: 'brown',
        chocolate: 'brown',
        camel: 'brown',
        white: 'white',
        ivory: 'white',
        cream: 'white',
        pearl: 'white',
        black: 'black',
        onyx: 'black',
        gray: 'gray',
        grey: 'gray',
        silver: 'gray',
        charcoal: 'gray',
        slate: 'gray',
        gold: 'gold',
        multicolor: 'multicolor',
        'multi color': 'multicolor',
        rainbow: 'multicolor',
        confetti: 'multicolor',
        mixed: 'multicolor',
        clear: 'clear',
        crystal: 'clear',
        transparent: 'clear',
        jelly: 'clear',
        glass: 'clear',
        glow: 'glow',
        neon: 'glow',
        fluorescent: 'glow',
        uv: 'glow',
        luminous: 'glow',
        'neon red':    'red',
        'neon orange': 'orange',
        'neon yellow': 'yellow',
        'neon green':  'green',
        'neon blue':   'blue',
        'neon pink':   'pink',
        'neon purple': 'purple'
      };
      var COLOR_ALIAS_KEYS = Object.keys(COLOR_ALIASES).sort(function(a, b) {
        return b.length - a.length;
      });
      // Team-colour words seen only in product descriptions (data-hd-derived-colors on sports
      // team collars). Used for description-derived colours only, so metafield swatches are unchanged.
      var DESCRIPTION_COLOR_ALIASES = {
        maroon: 'red',
        garnet: 'red',
        'golden yellow': 'gold'   // Pat 2026-11-01: also counts as Gold (the base aliases already give it Yellow)
      };
      var DESCRIPTION_COLOR_ALIAS_KEYS = Object.keys(DESCRIPTION_COLOR_ALIASES);
      var CANONICAL_SIZE_OPTIONS = [
        { key: 'xs', label: 'XS' },
        { key: 'mini', label: 'Mini' },
        { key: 'large_regular', label: 'Large (Regular)' },
        { key: 'xl_chunky', label: 'XL (Chunky)' }
      ];
      var SIZE_FILTER_OPTIONS = [
        { key: '', label: 'All sizes' },
        { key: 'xs', label: 'XS' },
        { key: 'mini', label: 'Mini' },
        { key: 'large_regular', label: 'Large (Regular)' },
        { key: 'xl_chunky', label: 'XL (Chunky)' },
        { key: 'other', label: 'Other' }
      ];
      var SIZE_KEY_MAP = {
        xs: 'xs',
        'x small': 'xs',
        xsmall: 'xs',
        'extra small': 'xs',
        extrasmall: 'xs',
        mini: 'mini',
        'large regular': 'large_regular',
        regular: 'large_regular',
        'bead size regular': 'large_regular',
        large: 'large_regular',
        'xl chunky': 'xl_chunky',
        jumbo: 'xl_chunky',
        chunky: 'xl_chunky',
        'bead size jumbo': 'xl_chunky',
        xl: 'xl_chunky',
        other: 'other'
      };
      var SIZE_FILTER_LABELS = {};
      SIZE_FILTER_OPTIONS.forEach(function(option) {
        SIZE_FILTER_LABELS[option.key] = option.label;
      });

      var colorIndex = {};
      var colorOrder = [];
      initializeColorIndex();
      serverColorFilterParamName = buildServerColorFilterParamName(colorMetafieldPath);
      initializeServerColorFilterValues();

      function initializeColorIndex() {
        colorIndex = {};
        colorOrder = [];
        BASE_COLOR_GROUPS.forEach(function(group) {
          colorIndex[group.key] = {
            key: group.key,
            label: group.label,
            swatch: group.swatch
          };
          colorOrder.push(group.key);
        });
      }

      function flattenValue(value, bucket) {
        if (value === null || typeof value === 'undefined') return;
        if (Array.isArray(value)) {
          value.forEach(function(item) {
            flattenValue(item, bucket);
          });
          return;
        }
        if (typeof value === 'object') {
          if (Object.prototype.hasOwnProperty.call(value, 'value')) {
            flattenValue(value.value, bucket);
            return;
          }
          Object.keys(value).forEach(function(key) {
            flattenValue(value[key], bucket);
          });
          return;
        }
        bucket.push(String(value));
      }

      function normalizeText(input) {
        return String(input || '')
          .toLowerCase()
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function normalizeColorText(input) {
        return String(input || '')
          .toLowerCase()
          .replace(/[_-]+/g, ' ')
          .replace(/[^a-z0-9\s]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function buildServerColorFilterParamName(path) {
        var normalizedPath = String(path || '')
          .replace(/\s+/g, '')
          .trim();
        if (!normalizedPath || normalizedPath.indexOf('.') === -1) return '';
        if (!/^[a-z0-9_.-]+$/i.test(normalizedPath)) return '';
        return 'filter.p.m.' + normalizedPath;
      }

      function registerServerColorFilterValue(colorKey, rawValue) {
        if (!colorKey) return;
        var normalizedValue = normalizeColorText(rawValue);
        if (!normalizedValue) return;
        if (!serverColorFilterValuesByKey[colorKey]) {
          serverColorFilterValuesByKey[colorKey] = [];
        }
        if (serverColorFilterValuesByKey[colorKey].indexOf(normalizedValue) !== -1) return;
        serverColorFilterValuesByKey[colorKey].push(normalizedValue);
      }

      function initializeServerColorFilterValues() {
        serverColorFilterValuesByKey = {};

        BASE_COLOR_GROUPS.forEach(function(group) {
          registerServerColorFilterValue(group.key, group.key);
          registerServerColorFilterValue(group.key, group.label);
        });

        Object.keys(COLOR_ALIASES).forEach(function(aliasKey) {
          var mappedKey = COLOR_ALIASES[aliasKey];
          if (!mappedKey) return;
          registerServerColorFilterValue(mappedKey, aliasKey);
        });
      }

      function getPrimarySelectedColorKey() {
        var key = '';
        colorOrder.forEach(function(colorKey) {
          if (key || !selectedColors.has(colorKey)) return;
          key = colorKey;
        });
        if (key) return key;
        selectedColors.forEach(function(colorKey) {
          if (key) return;
          key = colorKey;
        });
        return key;
      }

      function getServerColorFilterValues(colorKey) {
        if (!colorKey) return [];

        if (!serverColorFilterValuesByKey[colorKey] || serverColorFilterValuesByKey[colorKey].length === 0) {
          if (colorIndex[colorKey] && colorIndex[colorKey].label) {
            registerServerColorFilterValue(colorKey, colorIndex[colorKey].label);
          }
          if (colorKey.indexOf('custom-') !== 0) {
            registerServerColorFilterValue(colorKey, colorKey);
          }
        }

        return (serverColorFilterValuesByKey[colorKey] || []).slice();
      }

      function applyServerCriteriaParams(requestUrl) {
        if (!requestUrl || !requestUrl.searchParams) return;

        if (serverColorFilterParamName) {
          requestUrl.searchParams.delete(serverColorFilterParamName);
        }
        requestUrl.searchParams.delete(SERVER_STOCK_FILTER_PARAM_NAME);

        if (serverColorFilterParamName && selectedColors.size > 0) {
          var primaryColorKey = getPrimarySelectedColorKey();
          var serverValues = getServerColorFilterValues(primaryColorKey);
          // Query Shopify by one anchor color, then enforce full multi-color AND
          // client-side so product inclusion stays deterministic.
          serverValues.forEach(function(value) {
            requestUrl.searchParams.append(serverColorFilterParamName, value);
          });
        }

        if (stockFilterActive) {
          requestUrl.searchParams.set(SERVER_STOCK_FILTER_PARAM_NAME, '1');
        }
      }

      function addUniqueColorKey(bucket, key) {
        if (!key) return;
        if (bucket.indexOf(key) !== -1) return;
        bucket.push(key);
      }

      function parseMetafieldStrings(rawAttributeValue) {
        if (!rawAttributeValue || rawAttributeValue === 'null') return [];
        var parsedValue = rawAttributeValue;
        try {
          parsedValue = JSON.parse(rawAttributeValue);
        } catch (error) {
          parsedValue = rawAttributeValue;
        }

        var values = [];
        flattenValue(parsedValue, values);

        var splitValues = [];
        values.forEach(function(value) {
          String(value)
            .replace(/&/g, ',')
            .replace(/\band\b/gi, ',')
            .split(/[,/|;+]/)
            .forEach(function(part) {
              var clean = part.trim();
              if (clean) splitValues.push(clean);
            });
        });

        return splitValues;
      }

      function slugify(input) {
        return String(input || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function formatLabel(input) {
        return String(input || '')
          .trim()
          .replace(/\s+/g, ' ')
          .replace(/\b\w/g, function(character) {
            return character.toUpperCase();
          });
      }

      function ensureCustomColorGroup(normalizedToken, originalToken) {
        var slug = slugify(normalizedToken);
        if (!slug) return '';
        var key = 'custom-' + slug;
        if (!colorIndex[key]) {
          colorIndex[key] = {
            key: key,
            label: formatLabel(originalToken || normalizedToken),
            swatch: '#d8dde2'
          };
          colorOrder.push(key);
        }
        registerServerColorFilterValue(key, normalizedToken);
        registerServerColorFilterValue(key, originalToken);
        return key;
      }

      function extractColorKeysFromRaw(rawAttributeValue, options) {
        // fromDescription: free text from a product description. It may only map onto known
        // colours; leftover words ("matching XS resin rhinestone sparkle beads") never become swatches.
        var fromDescription = Boolean(options && options.fromDescription);
        var cacheKey = (fromDescription ? 'desc:' : '') + (rawAttributeValue == null ? '__hd_nil__' : String(rawAttributeValue));
        if (Object.prototype.hasOwnProperty.call(extractedColorKeysCache, cacheKey)) {
          return extractedColorKeysCache[cacheKey].slice();
        }

        var rawStrings = parseMetafieldStrings(rawAttributeValue);
        var foundKeys = [];
        if (rawStrings.length === 0) {
          extractedColorKeysCache[cacheKey] = [];
          return foundKeys;
        }

        rawStrings.forEach(function(rawValue) {
          var normalized = normalizeColorText(rawValue);
          if (!normalized) return;

          var matchedKnownColor = false;
          var exactKey = COLOR_ALIASES[normalized];
          if (!exactKey && colorIndex[normalized]) exactKey = normalized;
          if (exactKey) {
            addUniqueColorKey(foundKeys, exactKey);
            matchedKnownColor = true;
          }

          var paddedToken = ' ' + normalized + ' ';
          COLOR_ALIAS_KEYS.forEach(function(aliasKey) {
            if (paddedToken.indexOf(' ' + aliasKey + ' ') === -1) return;
            var mappedKey = COLOR_ALIASES[aliasKey];
            if (!mappedKey) return;
            addUniqueColorKey(foundKeys, mappedKey);
            matchedKnownColor = true;
          });

          if (fromDescription) {
            DESCRIPTION_COLOR_ALIAS_KEYS.forEach(function(aliasKey) {
              if (paddedToken.indexOf(' ' + aliasKey + ' ') === -1) return;
              addUniqueColorKey(foundKeys, DESCRIPTION_COLOR_ALIASES[aliasKey]);
            });
            return;
          }

          if (matchedKnownColor) return;

          var customKey = ensureCustomColorGroup(normalized, rawValue);
          addUniqueColorKey(foundKeys, customKey);
        });

        extractedColorKeysCache[cacheKey] = foundKeys.slice();
        return foundKeys;
      }

      function readCardColorKeys(card) {
        var metafieldKeys = extractColorKeysFromRaw(card.getAttribute('data-hd-color-metafield'));
        if (metafieldKeys.length > 0) return metafieldKeys;
        // No custom.filter_colors: fall back to the colours named in the description (Liquid
        // snippet hd-derived-colors, sports team collars only).
        return extractColorKeysFromRaw(card.getAttribute('data-hd-derived-colors'), { fromDescription: true });
      }

      function readCardPrimaryColorKey(card, fallbackColorKeys) {
        var raw = card.getAttribute('data-hd-primary-color');
        if (!raw || raw === 'null' || raw === 'NONE') {
          if (fallbackColorKeys && fallbackColorKeys.length > 0) return fallbackColorKeys[0];
          raw = card.getAttribute('data-hd-color-metafield');
        }
        if (!raw || raw === 'null' || raw === 'NONE') {
          return fallbackColorKeys && fallbackColorKeys.length > 0 ? fallbackColorKeys[0] : null;
        }

        var keys = extractColorKeysFromRaw(raw);
        if (keys.length > 0) return keys[0];
        return fallbackColorKeys && fallbackColorKeys.length > 0 ? fallbackColorKeys[0] : null;
      }

      function readCardSearchText(card) {
        // Colour names are searchable too ("purple"): the swatch labels the card filters under,
        // plus the description's own words ("maroon", "navy blue") when the colours came from it.
        var cardColorKeys = card._hdColorKeys || readCardColorKeys(card);
        // The same effective set the colour Filter matches on: colour keys plus the primary colour
        // (pick-your-team cards are Multicolor by primary only).
        var primaryColorKey = card._hdPrimaryColorKey || readCardPrimaryColorKey(card, cardColorKeys);
        var effectiveColorKeys = cardColorKeys.slice();
        if (primaryColorKey && effectiveColorKeys.indexOf(primaryColorKey) === -1) effectiveColorKeys.push(primaryColorKey);
        var searchBlob = [
          card.getAttribute('data-hd-product-title'),
          card.getAttribute('data-hd-product-type'),
          card.getAttribute('data-hd-product-tags'),
          card.getAttribute('data-hd-product-vendor'),
          card.getAttribute('data-hd-derived-colors'),
          effectiveColorKeys.map(colorLabel).join(' ')
        ].join(' ');
        return normalizeText(searchBlob);
      }

      function readCardSizeKeys(card) {
        var raw = String(card.getAttribute('data-hd-size-keys') || '');
        if (!raw) return [];

        var keys = [];
        var segments = raw.split(/[|,]/);
        segments.forEach(function(part) {
          var key = normalizeSizeKey(part);
          if (!key || keys.indexOf(key) !== -1) return;
          keys.push(key);
        });

        // Keep backward compatibility with legacy single-value payloads.
        if (keys.length === 0) {
          var fallbackKey = normalizeSizeKey(raw);
          if (fallbackKey) keys.push(fallbackKey);
        }

        return keys;
      }

      function normalizeSizeKey(value) {
        var normalized = String(value || '')
          .toLowerCase()
          .replace(/[()]/g, ' ')
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (!normalized) return '';
        return SIZE_KEY_MAP[normalized] || '';
      }

      function isValidSizeSelectionKey(key) {
        if (!key) return true;
        return Object.prototype.hasOwnProperty.call(SIZE_FILTER_LABELS, key);
      }

      function getSelectedSizeLabel() {
        if (!selectedSizeKey) return '';
        return SIZE_FILTER_LABELS[selectedSizeKey] || '';
      }

      function colorLabel(key) {
        if (colorIndex[key]) return colorIndex[key].label;
        return key;
      }

      function getSwatchTextColor(groupKey) {
        if (!groupKey) return '#ffffff';
        if (groupKey.indexOf('custom-') === 0) return '#2f1f45';
        return SWATCH_TEXT_BY_KEY[groupKey] || '#ffffff';
      }

      function hasSelectedColor(cardColorKeys, primaryColorKey) {
        if (selectedColors.size === 0) return true;

        // Build effective keys: union of filter_colors keys + primary_color key
        var effectiveKeys = cardColorKeys.slice();
        if (primaryColorKey && effectiveKeys.indexOf(primaryColorKey) === -1) {
          effectiveKeys.push(primaryColorKey);
        }

        if (selectedColors.size === 1) {
          // Single color: OR — show if card has this color anywhere (including primary)
          for (var i = 0; i < effectiveKeys.length; i += 1) {
            if (selectedColors.has(effectiveKeys[i])) return true;
          }
          return false;
        }

        // Multiple colors: AND — card must have ALL selected colors
        var allMatch = true;
        selectedColors.forEach(function(key) {
          if (effectiveKeys.indexOf(key) === -1) allMatch = false;
        });
        return allMatch;
      }

      function cardMatchesSize(cardSizeKeys) {
        if (!selectedSizeKey) return true;

        var normalizedKeys = Array.isArray(cardSizeKeys) ? cardSizeKeys : [];
        if (selectedSizeKey === 'other') {
          return normalizedKeys.length === 0 || normalizedKeys.indexOf('other') !== -1;
        }

        return normalizedKeys.indexOf(selectedSizeKey) !== -1;
      }

      function hasRemainingPages() {
        return Boolean(nextPageUrl || loadingNextPage);
      }

      function hasActiveCriteria() {
        return selectedColors.size > 0 || Boolean(selectedSizeKey) || Boolean(searchQuery) || stockFilterActive;
      }

      function cardMatchesSearch(cardSearchText) {
        if (searchTerms.length === 0) return true;
        if (!cardSearchText) return false;
        for (var i = 0; i < searchTerms.length; i += 1) {
          if (!searchTextHasTerm(cardSearchText, searchTerms[i])) return false;
        }
        return true;
      }

      // A colour word must start a word ("red" must not match "inspired", "tan" not "titans");
      // any other term still matches anywhere, as before.
      function searchTextHasTerm(text, term) {
        var index = text.indexOf(term);
        if (index === -1) return false;
        if (!COLOR_ALIASES[term] && !DESCRIPTION_COLOR_ALIASES[term]) return true;
        while (index !== -1) {
          if (index === 0 || !/[a-z0-9]/.test(text.charAt(index - 1))) return true;
          index = text.indexOf(term, index + 1);
        }
        return false;
      }

      function getActiveSortLabel() {
        if (!sortSelect) return '';
        var selectedOption = sortSelect.options[sortSelect.selectedIndex];
        if (!selectedOption) return '';
        return String(selectedOption.text || '').replace(/\s+/g, ' ').trim();
      }

      function getSelectedColorLabels() {
        var orderedLabels = [];
        colorOrder.forEach(function(key) {
          if (!selectedColors.has(key)) return;
          orderedLabels.push(colorLabel(key));
        });
        selectedColors.forEach(function(key) {
          if (colorOrder.indexOf(key) !== -1) return;
          orderedLabels.push(colorLabel(key));
        });
        return orderedLabels;
      }

      function buildColorSummaryText(labels) {
        if (!labels || labels.length === 0) return '';
        if (labels.length <= 2) return labels.join(', ');
        return labels.slice(0, 2).join(', ') + ' +' + (labels.length - 2);
      }

      function createControlsSummaryChip(type, label, valueText, fullText) {
        var chipEl = document.createElement('span');
        chipEl.className = 'hd-main-controls__summary-chip hd-main-controls__summary-chip--' + type;
        if (fullText) chipEl.setAttribute('title', fullText);

        var labelEl = document.createElement('strong');
        labelEl.textContent = label + ':';
        chipEl.appendChild(labelEl);

        var valueEl = document.createElement('span');
        valueEl.textContent = valueText;
        chipEl.appendChild(valueEl);
        return chipEl;
      }

      function updateControlsSummary() {
        if (!controlsSummaryEl) return;
        controlsSummaryEl.innerHTML = '';

        var activeSortValue = getActiveSortValue();
        var activeSortLabel = getActiveSortLabel();
        if (activeSortLabel && activeSortValue && activeSortValue !== defaultSortValue) {
          controlsSummaryEl.appendChild(createControlsSummaryChip('sort', 'Sort', activeSortLabel, activeSortLabel));
        }

        if (selectedColors.size > 0) {
          var colorLabels = getSelectedColorLabels();
          var shortColorText = buildColorSummaryText(colorLabels);
          var fullColorText = colorLabels.join(', ');
          controlsSummaryEl.appendChild(createControlsSummaryChip('filter', 'Colors', shortColorText, fullColorText));
        }

        if (selectedSizeKey) {
          var sizeLabel = getSelectedSizeLabel();
          if (sizeLabel) controlsSummaryEl.appendChild(createControlsSummaryChip('filter', 'Size', sizeLabel, sizeLabel));
        }

        if (searchQueryLabel) {
          controlsSummaryEl.appendChild(createControlsSummaryChip('search', 'Search', searchQueryLabel, searchQueryLabel));
        }

        if (stockFilterActive) {
          controlsSummaryEl.appendChild(createControlsSummaryChip('stock', 'Stock', 'In stock only', 'In stock only'));
        }

        controlsSummaryEl.hidden = controlsSummaryEl.children.length === 0;
      }

      function parseCartCountValue(rawValue) {
        var match = String(rawValue || '').match(/\d+/);
        if (!match) return 0;
        var parsed = parseInt(match[0], 10);
        if (!isFinite(parsed) || parsed < 0) return 0;
        return parsed;
      }

      function formatCartCountText(count) {
        if (count > 99) return '99+';
        return String(count);
      }

      function resolveHeaderCartElements() {
        if (!headerCartLinkEl) return;
        headerCartBubbleEl = document.getElementById('CartCount');
        if (!headerCartBubbleEl) {
          headerCartCountEl = null;
          return;
        }
        headerCartCountEl =
          headerCartBubbleEl.querySelector('span:not(.icon__fallback-text)') ||
          headerCartBubbleEl.querySelector('span');
      }

      function ensureHeaderCartBubble() {
        if (!headerCartLinkEl) return null;
        resolveHeaderCartElements();
        if (headerCartBubbleEl) return headerCartBubbleEl;

        var bubbleEl = document.createElement('div');
        bubbleEl.setAttribute('id', 'CartCount');
        bubbleEl.className = 'site-header__cart-count';
        var countEl = document.createElement('span');
        bubbleEl.appendChild(countEl);
        headerCartLinkEl.appendChild(bubbleEl);
        headerCartBubbleEl = bubbleEl;
        headerCartCountEl = countEl;
        return headerCartBubbleEl;
      }

      function setStickyCartCount(count) {
        if (!stickyCartCountEl) return;
        var safeCount = Math.max(0, Number(parseInt(count, 10) || 0));
        if (safeCount > 0) {
          stickyCartCountEl.hidden = false;
          stickyCartCountEl.textContent = formatCartCountText(safeCount);
        } else {
          stickyCartCountEl.hidden = true;
          stickyCartCountEl.textContent = '0';
        }

        if (stickyCartButtonEl) {
          var nextLabel = safeCount > 0 ? ('Open cart with ' + safeCount + ' item' + (safeCount === 1 ? '' : 's')) : 'Open cart';
          stickyCartButtonEl.setAttribute('aria-label', nextLabel);
        }
      }

      function setHeaderCartCount(count) {
        if (!headerCartLinkEl) return;
        var safeCount = Math.max(0, Number(parseInt(count, 10) || 0));
        resolveHeaderCartElements();

        if (safeCount <= 0) {
          if (headerCartBubbleEl && headerCartBubbleEl.parentNode) {
            headerCartBubbleEl.parentNode.removeChild(headerCartBubbleEl);
          }
          headerCartBubbleEl = null;
          headerCartCountEl = null;
          return;
        }

        if (!headerCartBubbleEl) ensureHeaderCartBubble();
        if (!headerCartCountEl && headerCartBubbleEl) {
          headerCartCountEl = headerCartBubbleEl.querySelector('span');
        }
        if (!headerCartCountEl) return;
        headerCartCountEl.textContent = formatCartCountText(safeCount);
      }

      function syncCartCountUI(count) {
        var safeCount = Math.max(0, Number(parseInt(count, 10) || 0));
        setStickyCartCount(safeCount);
        setHeaderCartCount(safeCount);
      }

      function getHeaderCartCount() {
        resolveHeaderCartElements();
        if (!headerCartCountEl) return 0;
        return parseCartCountValue(headerCartCountEl.textContent || '');
      }

      function refreshCartCountFromStore() {
        if (typeof fetch !== 'function') return Promise.resolve(false);
        return fetch('/cart.js', {
          credentials: 'same-origin'
        })
          .then(function(response) {
            if (!response.ok) throw new Error('cart refresh failed');
            return response.json();
          })
          .then(function(cartData) {
            var itemCount = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;
            syncCartCountUI(itemCount);
            return true;
          })
          .catch(function() {
            setStickyCartCount(getHeaderCartCount());
            return false;
          });
      }

      // ---- Cart Drawer Functions ----

      function fetchCartData() {
        if (typeof fetch !== 'function') return Promise.resolve(null);
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(response) {
            if (!response.ok) throw new Error('cart fetch failed');
            return response.json();
          })
          .then(function(cartData) {
            cartDrawerCachedData = cartData;
            var itemCount = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;
            syncCartCountUI(itemCount);
            return cartData;
          })
          .catch(function() {
            return null;
          });
      }

      function renderCartDrawer(cartData) {
        if (!cartDrawerBodyEl) return;
        if (cartDrawerLoadingEl) cartDrawerLoadingEl.hidden = true;

        if (!cartData || !cartData.items || cartData.items.length === 0) {
          if (cartDrawerEmptyEl) cartDrawerEmptyEl.hidden = false;
          if (cartDrawerItemsEl) cartDrawerItemsEl.innerHTML = '';
          if (cartDrawerFooterEl) cartDrawerFooterEl.hidden = true;
          if (cartDrawerBadgeEl) cartDrawerBadgeEl.hidden = true;
          return;
        }

        if (cartDrawerEmptyEl) cartDrawerEmptyEl.hidden = true;
        if (cartDrawerFooterEl) cartDrawerFooterEl.hidden = false;

        var badgeCount = cartData.item_count || 0;
        if (cartDrawerBadgeEl) {
          cartDrawerBadgeEl.textContent = String(badgeCount);
          cartDrawerBadgeEl.hidden = badgeCount === 0;
        }

        if (cartDrawerSubtotalEl) {
          cartDrawerSubtotalEl.textContent = formatQuickAddMoney(cartData.total_price);
        }

        if (cartDrawerItemsEl) {
          var html = '';
          for (var i = 0; i < cartData.items.length; i++) {
            var item = cartData.items[i];
            var imgSrc = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x180_crop_center$1$2') : '';
            var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            html += '<li class="hd-cart-drawer__item" data-hd-cart-key="' + escapeHtml(item.key) + '">';
            if (imgSrc) {
              html += '<img class="hd-cart-drawer__item-image" src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">';
            }
            html += '<div class="hd-cart-drawer__item-details">';
            html += '<p class="hd-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>';
            if (variantTitle) {
              html += '<p class="hd-cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</p>';
            }
            html += '<p class="hd-cart-drawer__item-price">' + formatQuickAddMoney(item.final_line_price) + '</p>';
            html += '<div class="hd-cart-drawer__qty-row">';
            html += '<button type="button" class="hd-cart-drawer__qty-btn" data-hd-cart-qty-change="-1" data-hd-cart-key="' + escapeHtml(item.key) + '" aria-label="Decrease quantity">&minus;</button>';
            html += '<span class="hd-cart-drawer__qty-count">' + item.quantity + '</span>';
            html += '<button type="button" class="hd-cart-drawer__qty-btn" data-hd-cart-qty-change="+1" data-hd-cart-key="' + escapeHtml(item.key) + '" aria-label="Increase quantity">&plus;</button>';
            html += '<button type="button" class="hd-cart-drawer__remove" data-hd-cart-remove data-hd-cart-key="' + escapeHtml(item.key) + '">Remove</button>';
            html += '</div>';
            html += '</div>';
            html += '</li>';
          }
          cartDrawerItemsEl.innerHTML = html;
        }
      }

      function isCartDrawerOpen() {
        return cartDrawerEl && cartDrawerEl.classList.contains('is-open');
      }

      function openCartDrawer() {
        if (!cartDrawerEl || !cartDrawerPanelEl) return;
        closeActiveDrawer();
        cartDrawerEl.classList.add('is-open');
        cartDrawerEl.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hd-cart-drawer-open');

        if (cartDrawerLoadingEl) cartDrawerLoadingEl.hidden = false;
        if (cartDrawerEmptyEl) cartDrawerEmptyEl.hidden = true;
        if (cartDrawerItemsEl) cartDrawerItemsEl.innerHTML = '';
        if (cartDrawerFooterEl) cartDrawerFooterEl.hidden = true;

        fetchCartData().then(function(cartData) {
          if (isCartDrawerOpen()) {
            renderCartDrawer(cartData);
          }
        });

        cartDrawerPanelEl.focus();
      }

      function closeCartDrawer() {
        if (!cartDrawerEl) return;
        cartDrawerEl.classList.remove('is-open');
        cartDrawerEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hd-cart-drawer-open');
      }

      function updateCartItem(itemKey, newQuantity) {
        var qty = Math.max(0, Number(parseInt(newQuantity, 10) || 0));
        var itemEl = cartDrawerItemsEl ? cartDrawerItemsEl.querySelector('[data-hd-cart-key="' + itemKey + '"]') : null;

        // Optimistic UI
        if (itemEl) {
          if (qty === 0) {
            itemEl.classList.add('is-removing');
          } else {
            var countEl = itemEl.querySelector('.hd-cart-drawer__qty-count');
            if (countEl) countEl.textContent = String(qty);
          }
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: qty })
        })
          .then(function(response) {
            if (!response.ok) throw new Error('cart update failed');
            return response.json();
          })
          .then(function(cartData) {
            cartDrawerCachedData = cartData;
            syncCartCountUI(cartData.item_count || 0);
            renderCartDrawer(cartData);
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e) {}
          })
          .catch(function() {
            // Refetch to restore correct state
            fetchCartData().then(function(cartData) {
              if (isCartDrawerOpen()) renderCartDrawer(cartData);
            });
          });
      }

      function setupCartDrawer() {
        if (!cartDrawerEl || !stickyCartButtonEl) return;

        stickyCartButtonEl.addEventListener('click', function(e) {
          e.preventDefault();
          openCartDrawer();
        });

        cartDrawerEl.addEventListener('click', function(e) {
          var closeTarget = e.target.closest('[data-hd-cart-drawer-close]');
          if (closeTarget) {
            closeCartDrawer();
            return;
          }

          var qtyBtn = e.target.closest('[data-hd-cart-qty-change]');
          if (qtyBtn) {
            var key = qtyBtn.getAttribute('data-hd-cart-key');
            var delta = parseInt(qtyBtn.getAttribute('data-hd-cart-qty-change'), 10) || 0;
            var itemLi = qtyBtn.closest('.hd-cart-drawer__item');
            var currentQty = 0;
            if (itemLi) {
              var cntEl = itemLi.querySelector('.hd-cart-drawer__qty-count');
              if (cntEl) currentQty = parseInt(cntEl.textContent, 10) || 0;
            }
            var newQty = Math.max(0, currentQty + delta);
            if (newQty === 0) newQty = 1; // Use remove button for deletion
            updateCartItem(key, newQty);
            return;
          }

          var removeBtn = e.target.closest('[data-hd-cart-remove]');
          if (removeBtn) {
            var removeKey = removeBtn.getAttribute('data-hd-cart-key');
            updateCartItem(removeKey, 0);
            return;
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && isCartDrawerOpen()) {
            closeCartDrawer();
          }
        });

        var cartRefreshDrawerEvents = ['cart:refresh', 'cart-item-added', 'cart-item-removed', 'cart-item-changed'];
        cartRefreshDrawerEvents.forEach(function(eventName) {
          document.addEventListener(eventName, function() {
            if (isCartDrawerOpen()) {
              fetchCartData().then(function(cartData) {
                if (isCartDrawerOpen()) renderCartDrawer(cartData);
              });
            }
          });
        });
      }

      function queueCartCountRefresh(delayMs) {
        if (cartCountRefreshTimer) {
          window.clearTimeout(cartCountRefreshTimer);
          cartCountRefreshTimer = null;
        }
        var waitMs = Math.max(0, Number(parseInt(delayMs, 10) || 0));
        cartCountRefreshTimer = window.setTimeout(function() {
          cartCountRefreshTimer = null;
          refreshCartCountFromStore();
        }, waitMs);
      }

      function setupStickyCartSync() {
        if (!stickyCartButtonEl) return;

        setStickyCartCount(getHeaderCartCount());
        queueCartCountRefresh(0);

        if (headerCartLinkEl && window.MutationObserver) {
          var headerCartObserver = new MutationObserver(function() {
            setStickyCartCount(getHeaderCartCount());
          });
          headerCartObserver.observe(headerCartLinkEl, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        var cartRefreshEvents = ['cart:refresh', 'cart-item-added', 'cart-item-removed', 'cart-item-changed'];
        cartRefreshEvents.forEach(function(eventName) {
          document.addEventListener(eventName, function() {
            queueCartCountRefresh(140);
          });
          window.addEventListener(eventName, function() {
            queueCartCountRefresh(140);
          });
        });

        document.addEventListener('submit', function(event) {
          var formEl = event.target;
          if (!formEl || !formEl.getAttribute) return;
          var action = String(formEl.getAttribute('action') || '');
          if (action.indexOf('/cart/add') === -1) return;
          if (formEl.classList && formEl.classList.contains('hd-quick-add__form')) {
            queueCartCountRefresh(220);
            return;
          }
          queueCartCountRefresh(1000);
        }, true);

        document.addEventListener('click', function(event) {
          var addButton = event.target.closest('[data-add-to-cart], button[name="add"], .mw-apo-add-to-cart-cloned, #mwAddToCart');
          if (!addButton) return;
          queueCartCountRefresh(1000);
        }, true);

        document.addEventListener('visibilitychange', function() {
          if (document.visibilityState !== 'visible') return;
          queueCartCountRefresh(120);
        });

        window.addEventListener('focus', function() {
          queueCartCountRefresh(120);
        });

        window.addEventListener('pageshow', function() {
          queueCartCountRefresh(0);
        });
      }

      function escapeHtml(input) {
        return String(input || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function normalizeQuickAddUrl(href, fallbackHandle) {
        var safeHref = String(href || '').trim();
        if (!safeHref && fallbackHandle) {
          safeHref = '/products/' + encodeURIComponent(String(fallbackHandle || '').trim());
        }
        if (!safeHref) return '/collections/all';
        try {
          var parsed = new URL(safeHref, window.location.origin);
          return parsed.pathname + parsed.search + parsed.hash;
        } catch (error) {
          return safeHref;
        }
      }

      function formatQuickAddMoney(centsRaw) {
        var cents = Number(parseInt(centsRaw, 10) || 0);
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.mwApoInit && window.mwApoInit.shop_money_format) {
          try {
            return window.Shopify.formatMoney(cents, window.mwApoInit.shop_money_format);
          } catch (error) {}
        }
        var dollars = (Math.max(0, cents) / 100).toFixed(2);
        return '$' + dollars;
      }

      function clearQuickAddStatusTone() {
        if (!quickAddStatusEl) return;
        quickAddStatusEl.classList.remove('is-success');
        quickAddStatusEl.classList.remove('is-error');
      }

      function setQuickAddStatus(messageText, tone) {
        if (!quickAddStatusEl) return;
        clearQuickAddStatusTone();
        if (tone === 'success') quickAddStatusEl.classList.add('is-success');
        if (tone === 'error') quickAddStatusEl.classList.add('is-error');
        quickAddStatusEl.textContent = String(messageText || '').replace(/\s+/g, ' ').trim() || 'Preparing product options...';
      }

      function setQuickAddTitle(productTitle) {
        var normalizedTitle = String(productTitle || '').replace(/\s+/g, ' ').trim() || 'Product';
        if (quickAddTitleProductEl) {
          quickAddTitleProductEl.textContent = normalizedTitle;
          return;
        }
        if (quickAddTitleEl) {
          quickAddTitleEl.textContent = 'Quick Add: ' + normalizedTitle;
        }
      }

      function disconnectQuickAddObserver() {
        if (!quickAddModalObserver) return;
        quickAddModalObserver.disconnect();
        quickAddModalObserver = null;
      }

      function disconnectQuickAddGuidedObserver() {
        if (!quickAddGuidedObserver) return;
        quickAddGuidedObserver.disconnect();
        quickAddGuidedObserver = null;
      }

      function clearQuickAddGuidedRenderTimer() {
        if (!quickAddGuidedRenderTimer) return;
        window.clearTimeout(quickAddGuidedRenderTimer);
        quickAddGuidedRenderTimer = null;
      }

      function clearQuickAddNoOptionsTimer() {
        if (!quickAddNoOptionsTimer) return;
        window.clearTimeout(quickAddNoOptionsTimer);
        quickAddNoOptionsTimer = null;
      }

      function isQuickAddElementVisible(element) {
        if (!element) return false;
        if (element.hidden) return false;
        if (element.classList && element.classList.contains('mw-hidden')) return false;
        var computed = window.getComputedStyle ? window.getComputedStyle(element) : null;
        if (!computed) return true;
        if (computed.display === 'none') return false;
        if (computed.visibility === 'hidden') return false;
        return true;
      }

      function normalizeQuickAddFieldText(input) {
        return String(input || '').replace(/\s+/g, ' ').trim();
      }

      function getQuickAddGuidedNativeElement() {
        if (!quickAddMountEl) return null;
        var nativeEl = quickAddMountEl.querySelector('[data-hd-quick-add-options]');
        if (!nativeEl) {
          nativeEl = quickAddMountEl.querySelector('.mw-apo-container, .mw-options-container');
        }
        if (nativeEl && nativeEl.classList) nativeEl.classList.add('hd-quick-add-native');
        return nativeEl || null;
      }

      function getQuickAddGuidedElements() {
        if (!quickAddMountEl) return null;
        return {
          root: quickAddMountEl.querySelector('[data-hd-quick-add-guided]'),
          progress: quickAddMountEl.querySelector('[data-hd-quick-add-guided-progress]'),
          fields: quickAddMountEl.querySelector('[data-hd-quick-add-guided-fields]'),
          native: getQuickAddGuidedNativeElement()
        };
      }

      function setQuickAddNativeVisibility(nativeEl, shouldHide) {
        if (!nativeEl || !nativeEl.classList) return;
        if (shouldHide) {
          nativeEl.classList.add('is-guided-hidden');
        } else {
          nativeEl.classList.remove('is-guided-hidden');
        }
      }

      function isQuickAddGuidedNode(node) {
        if (!node) return false;
        if (node.nodeType === 3) {
          return Boolean(node.parentElement && node.parentElement.closest && node.parentElement.closest('[data-hd-quick-add-guided]'));
        }
        if (node.nodeType !== 1) return false;
        if (node.matches && node.matches('[data-hd-quick-add-guided]')) return true;
        return Boolean(node.closest && node.closest('[data-hd-quick-add-guided]'));
      }

      function shouldRebuildGuidedFromMutations(mutations) {
        if (!mutations || !mutations.length) return true;
        return mutations.some(function(mutation) {
          if (!isQuickAddGuidedNode(mutation.target)) return true;
          var addedNodes = Array.prototype.slice.call(mutation.addedNodes || []);
          var removedNodes = Array.prototype.slice.call(mutation.removedNodes || []);
          if (addedNodes.some(function(node) { return !isQuickAddGuidedNode(node); })) return true;
          if (removedNodes.some(function(node) { return !isQuickAddGuidedNode(node); })) return true;
          return false;
        });
      }

      function getQuickAddOptionLabel(optionEl, fallbackLabel) {
        if (!optionEl) return fallbackLabel || 'Option';
        var strongEl = optionEl.querySelector('.mw-text--style-strong');
        var labelText = normalizeQuickAddFieldText(strongEl ? strongEl.textContent : '');
        if (!labelText) {
          var labelEl = optionEl.querySelector('label.mw-label');
          labelText = normalizeQuickAddFieldText(labelEl ? labelEl.textContent : '');
        }
        return labelText || fallbackLabel || 'Option';
      }

      function readQuickAddControlValue(controlEl) {
        if (!controlEl) return '';
        if (typeof controlEl.value === 'undefined' || controlEl.value === null) return '';
        return String(controlEl.value);
      }

      function setQuickAddControlValue(controlEl, nextValue, dispatchMode) {
        if (!controlEl) return;
        var normalizedValue = String(nextValue || '');
        if (String(controlEl.value || '') === normalizedValue) return;
        controlEl.value = normalizedValue;
        if (dispatchMode === 'none') return;
        if (dispatchMode === 'input') {
          controlEl.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
        controlEl.dispatchEvent(new Event('change', { bubbles: true }));
        controlEl.dispatchEvent(new Event('input', { bubbles: true }));
      }

      function getQuickAddSelectChoices(selectEl) {
        if (!selectEl || !selectEl.options) return [];
        var choices = [];
        Array.prototype.slice.call(selectEl.options).forEach(function(optionEl) {
          if (!optionEl) return;
          var optionValue = String(optionEl.value || '');
          if (!optionValue) return;
          if (optionEl.hidden || optionEl.classList.contains('mw-hidden')) return;
          if (optionEl.disabled && !optionEl.selected) return;
          var optionLabel = normalizeQuickAddFieldText(optionEl.textContent || '');
          if (!optionLabel) return;
          choices.push({
            value: optionValue,
            label: optionLabel
          });
        });
        return choices;
      }

      function chooseQuickAddSelectMode(labelText, choices) {
        if (!choices || choices.length === 0) return 'select';
        if (choices.length <= 5) return 'chips';
        var normalizedLabel = String(labelText || '').toLowerCase();
        if (choices.length <= 8 && /(style|buckle|slip|color|hardware)/.test(normalizedLabel)) return 'chips';
        return 'select';
      }

      function buildQuickAddGuidedModels() {
        if (!quickAddMountEl) return [];
        var optionNodes = Array.prototype.slice.call(
          quickAddMountEl.querySelectorAll('.mw-apo-container .mw-option[data-option-id], .mw-options-container .mw-option[data-option-id]')
        );
        var models = [];
        optionNodes.forEach(function(optionEl, index) {
          if (!isQuickAddElementVisible(optionEl)) return;
          var controlEl = optionEl.querySelector('.mw-option__control');
          if (!controlEl) return;
          if (!isQuickAddElementVisible(controlEl)) return;

          var controlTag = String(controlEl.tagName || '').toLowerCase();
          var modelType = controlTag === 'select' ? 'select' : (controlTag === 'textarea' ? 'textarea' : 'native');
          var labelText = getQuickAddOptionLabel(optionEl, 'Option ' + (index + 1));
          var required = optionEl.classList.contains('mw-option--required');
          var requiredHelpEl = optionEl.querySelector('.mw-option__helptext[data-helptext-type="required"]');
          var requiredHelpText = normalizeQuickAddFieldText(requiredHelpEl ? requiredHelpEl.textContent : '');
          var choices = modelType === 'select' ? getQuickAddSelectChoices(controlEl) : [];
          var currentValue = readQuickAddControlValue(controlEl);

          models.push({
            id: optionEl.getAttribute('data-option-id') || ('hd-quick-add-guided-' + index),
            index: index,
            type: modelType,
            label: labelText,
            required: required,
            requiredHelp: requiredHelpText,
            control: controlEl,
            optionNode: optionEl,
            choices: choices,
            mode: modelType === 'select' ? chooseQuickAddSelectMode(labelText, choices) : 'native',
            value: currentValue
          });
        });
        return models;
      }

      function normalizeQuickAddSummaryLabel(labelText) {
        var normalized = normalizeQuickAddFieldText(labelText);
        if (!normalized) return '';
        normalized = normalized.replace(/\s*\*+\s*$/, '');
        normalized = normalized.replace(/:\s*$/, '');
        return normalized;
      }

      function truncateQuickAddSummaryValue(valueText, maxLength) {
        var normalized = normalizeQuickAddFieldText(valueText);
        if (!normalized) return '';
        var safeMax = Math.max(8, Number(parseInt(maxLength, 10) || 46));
        if (normalized.length <= safeMax) return normalized;
        return normalized.slice(0, safeMax - 1).trim() + '…';
      }

      function stripQuickAddPriceAdjustmentText(valueText) {
        var normalized = normalizeQuickAddFieldText(valueText);
        if (!normalized) return '';
        var withoutPrice = normalized
          .replace(/\s*\(\s*[+-]?\s*\$[\d,.]+(?:\s*[A-Z]{3})?\s*\)\s*$/ig, '')
          .replace(/\s*[+-]\s*\$[\d,.]+(?:\s*[A-Z]{3})?\s*$/ig, '')
          .trim();
        return withoutPrice || normalized;
      }

      function compactQuickAddSummaryChoiceLabel(choiceLabel) {
        var normalized = stripQuickAddPriceAdjustmentText(choiceLabel);
        if (!normalized) return '';
        normalized = normalized.replace(/:\s*$/, '');
        if (normalized.length > 34) {
          var withoutTrailingDetails = normalized.replace(/\s*\([^)]*\)\s*$/, '').replace(/:\s*$/, '');
          if (withoutTrailingDetails && withoutTrailingDetails.length >= 4) normalized = withoutTrailingDetails;
        }
        return normalized;
      }

      function buildQuickAddSelectionFingerprint(valueText) {
        var normalized = stripQuickAddPriceAdjustmentText(valueText);
        if (!normalized) return '';
        normalized = String(normalized || '').toLowerCase();
        normalized = normalized.replace(/["']/g, '');
        normalized = normalized.replace(/\b(styles?|options?|types?|choices?|selection|selections)\b/g, ' ');
        normalized = normalized.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
        return normalized;
      }

      function escapeQuickAddRegex(text) {
        return String(text || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      function isQuickAddSummaryEntryRedundant(entry, allEntries, entryIndex) {
        if (!entry || !entry.fingerprint) return true;
        for (var i = 0; i < allEntries.length; i += 1) {
          if (i === entryIndex) continue;
          var other = allEntries[i];
          if (!other || !other.fingerprint) continue;
          if (other.fingerprint === entry.fingerprint && i < entryIndex) return true;
          if (other.fingerprint.length <= entry.fingerprint.length) continue;
          var tokenCount = entry.fingerprint.split(' ').filter(Boolean).length;
          if (tokenCount < 2) continue;
          var redundancyPattern = new RegExp('(^|\\s)' + escapeQuickAddRegex(entry.fingerprint) + '(\\s|$)');
          if (redundancyPattern.test(other.fingerprint)) return true;
        }
        return false;
      }

      function getQuickAddModelSelectionText(model) {
        if (!model) return '';
        var selectedValue = normalizeQuickAddFieldText(readQuickAddControlValue(model.control));
        if (!selectedValue) return '';

        if (model.type === 'select') {
          var matchedChoice = (model.choices || []).find(function(choice) {
            return String(choice.value || '') === String(selectedValue);
          });
          if (matchedChoice && matchedChoice.label) {
            return truncateQuickAddSummaryValue(compactQuickAddSummaryChoiceLabel(matchedChoice.label), 42);
          }
          if (model.control && model.control.options && model.control.selectedIndex >= 0) {
            var selectedOption = model.control.options[model.control.selectedIndex];
            var optionLabel = compactQuickAddSummaryChoiceLabel(selectedOption ? selectedOption.textContent : '');
            if (optionLabel && optionLabel !== '-- Please Select --') {
              return truncateQuickAddSummaryValue(optionLabel, 42);
            }
          }
          return truncateQuickAddSummaryValue(compactQuickAddSummaryChoiceLabel(selectedValue), 42);
        }

        if (model.type === 'textarea' && model.required) {
          var modelLabel = normalizeQuickAddSummaryLabel(model.label);
          if (modelLabel) return truncateQuickAddSummaryValue(modelLabel + ': ' + selectedValue, 56);
          return truncateQuickAddSummaryValue(selectedValue, 56);
        }

        return '';
      }

      function buildQuickAddSelectionsSummary(models) {
        if (!models || models.length === 0) return 'None yet';
        var selections = [];
        models.forEach(function(model) {
          var selectionText = getQuickAddModelSelectionText(model);
          if (!selectionText) return;
          var cleanedText = stripQuickAddPriceAdjustmentText(selectionText);
          if (!cleanedText) return;
          selections.push({
            text: truncateQuickAddSummaryValue(cleanedText, 34),
            fingerprint: buildQuickAddSelectionFingerprint(cleanedText)
          });
        });
        if (selections.length === 0) return 'None yet';
        var compactSelections = selections.filter(function(selection, selectionIndex) {
          return !isQuickAddSummaryEntryRedundant(selection, selections, selectionIndex);
        });
        if (compactSelections.length === 0) compactSelections = [selections[selections.length - 1]];
        return compactSelections.map(function(selection) { return selection.text; }).join(' • ');
      }

      function setQuickAddSelectionsSummary(summaryText) {
        if (!quickAddMountEl) return;
        var summaryValueEl = quickAddMountEl.querySelector('[data-hd-quick-add-selection-value]');
        if (!summaryValueEl) return;
        var normalizedSummary = normalizeQuickAddFieldText(summaryText);
        if (!normalizedSummary) normalizedSummary = 'None yet';
        summaryValueEl.textContent = normalizedSummary;
        summaryValueEl.setAttribute('title', normalizedSummary === 'None yet' ? '' : normalizedSummary);
      }

      function setQuickAddBasicMode(isBasicMode, options) {
        if (!quickAddMountEl) return;
        var basicMode = Boolean(isBasicMode);
        var formEl = quickAddMountEl.querySelector('.hd-quick-add__form');
        var actionsEl = quickAddMountEl.querySelector('[data-hd-quick-add-actions]');
        var basicHintEl = quickAddMountEl.querySelector('[data-hd-quick-add-basic-hint]');
        var summaryBarEl = quickAddMountEl.querySelector('.hd-quick-add__selection-bar');
        var submitButton = quickAddMountEl.querySelector('.hd-quick-add__submit');
        var guidedEls = getQuickAddGuidedElements();
        var buttonLabel = options && options.buttonLabel ? String(options.buttonLabel) : 'Add to cart';

        if (formEl && formEl.classList) formEl.classList.toggle('is-basic', basicMode);
        if (actionsEl && actionsEl.classList) actionsEl.classList.toggle('is-basic', basicMode);
        if (basicHintEl) basicHintEl.hidden = !basicMode;
        if (summaryBarEl) summaryBarEl.hidden = basicMode;
        if (guidedEls && guidedEls.root && basicMode) {
          guidedEls.root.hidden = true;
          if (guidedEls.fields) guidedEls.fields.innerHTML = '';
          if (guidedEls.progress) {
            guidedEls.progress.hidden = true;
            guidedEls.progress.textContent = '';
          }
          setQuickAddNativeVisibility(guidedEls.native, true);
          quickAddGuidedLastSignature = 'basic-mode';
        }
        if (submitButton) {
          submitButton.textContent = buttonLabel;
          if (basicMode) {
            submitButton.setAttribute('data-hd-basic-add', 'true');
          } else {
            submitButton.removeAttribute('data-hd-basic-add');
          }
        }
      }

      function isQuickAddBasicMode() {
        if (!quickAddMountEl) return false;
        var formEl = quickAddMountEl.querySelector('.hd-quick-add__form');
        return Boolean(formEl && formEl.classList && formEl.classList.contains('is-basic'));
      }

      function scheduleQuickAddNoOptionsFallback(requestToken) {
        clearQuickAddNoOptionsTimer();
        quickAddNoOptionsTimer = window.setTimeout(function() {
          quickAddNoOptionsTimer = null;
          if (requestToken && requestToken !== quickAddCurrentToken) return;
          if (!quickAddModalEl || !quickAddModalEl.classList.contains('is-open')) return;
          if (!quickAddMountEl || isQuickAddBasicMode()) return;

          var submitButton = quickAddMountEl.querySelector('.hd-quick-add__submit');
          if (!submitButton) return;

          var optionNodes = quickAddMountEl.querySelectorAll(
            '.mw-apo-container .mw-option[data-option-id], .mw-options-container .mw-option[data-option-id]'
          );
          var nativeContainer = quickAddMountEl.querySelector('.mw-apo-container, .mw-options-container');
          var hasVisibleOptionField = Array.prototype.slice.call(optionNodes || []).some(function(optionEl) {
            return isQuickAddElementVisible(optionEl);
          });
          if (hasVisibleOptionField) return;
          if (nativeContainer && nativeContainer.children && nativeContainer.children.length > 0) return;

          disconnectQuickAddObserver();
          disconnectQuickAddGuidedObserver();
          clearQuickAddGuidedRenderTimer();
          setQuickAddStatus('No custom options needed. Add this item directly to cart.', 'success');
          submitButton.removeAttribute('disabled');
          setQuickAddBasicMode(true, { buttonLabel: 'Add to cart' });
        }, 4200);
      }

      function syncQuickAddTextareaControls() {
        if (!quickAddMountEl) return;
        var guidedTextareas = Array.prototype.slice.call(
          quickAddMountEl.querySelectorAll('.hd-quick-add__guided-textarea[data-hd-guided-option-id]')
        );
        if (guidedTextareas.length === 0) return;

        guidedTextareas.forEach(function(guidedTextareaEl) {
          if (!guidedTextareaEl) return;
          var optionId = String(guidedTextareaEl.getAttribute('data-hd-guided-option-id') || '').trim();
          if (!optionId) return;
          var nativeControlEl = quickAddMountEl.querySelector(
            '.mw-option[data-option-id="' + optionId.replace(/"/g, '\\"') + '"] .mw-option__control'
          );
          if (!nativeControlEl) return;
          setQuickAddControlValue(nativeControlEl, guidedTextareaEl.value || '', 'change');
        });
      }

      function buildQuickAddGuidedSignature(models, stepText, hideNative, selectionsSummary) {
        if (!models || models.length === 0) return 'empty';
        var headerSignature = (hideNative ? 'guided' : 'mixed') + '|' + String(stepText || '') + '|' + String(selectionsSummary || '');
        var modelSignature = models.map(function(model) {
          var parts = [
            String(model.id || ''),
            String(model.type || ''),
            model.required ? '1' : '0',
            String(model.mode || ''),
            String(readQuickAddControlValue(model.control) || '')
          ];
          if (model.type === 'select') {
            var choicesSignature = (model.choices || []).map(function(choice) {
              return String(choice.value || '');
            }).join(',');
            parts.push(choicesSignature);
          }
          return parts.join('~');
        }).join('||');
        return headerSignature + '::' + modelSignature;
      }

      function isQuickAddModelComplete(model) {
        if (!model || !model.required) return true;
        var value = normalizeQuickAddFieldText(readQuickAddControlValue(model.control));
        return value !== '';
      }

      function buildQuickAddStepText(requiredModels, completeCount) {
        if (!requiredModels || requiredModels.length === 0) return '';
        if (completeCount >= requiredModels.length) return 'All required options selected. You can add to cart.';
        var nextStep = completeCount + 1;
        return 'Step ' + nextStep + ' of ' + requiredModels.length + ' required selections';
      }

      function renderQuickAddGuidedUi(requestToken) {
        var guidedEls = getQuickAddGuidedElements();
        if (!guidedEls || !guidedEls.root || !guidedEls.fields) return false;
        if (requestToken && requestToken !== quickAddCurrentToken) return false;

        var models = buildQuickAddGuidedModels();
        if (models.length === 0) {
          setQuickAddSelectionsSummary('None yet');
          if (quickAddGuidedLastSignature === 'empty') return false;
          quickAddGuidedLastSignature = 'empty';
          guidedEls.root.hidden = true;
          guidedEls.fields.innerHTML = '';
          if (guidedEls.progress) {
            guidedEls.progress.hidden = true;
            guidedEls.progress.textContent = '';
          }
          setQuickAddNativeVisibility(guidedEls.native, false);
          return false;
        }

        var supportedModelCount = models.filter(function(model) {
          return model.type === 'select' || model.type === 'textarea';
        }).length;
        var hasNativeFallback = models.some(function(model) {
          return model.type === 'native';
        });
        var selectionsSummary = buildQuickAddSelectionsSummary(models);
        if (supportedModelCount === 0) {
          setQuickAddSelectionsSummary(selectionsSummary);
          if (quickAddGuidedLastSignature === 'unsupported') return false;
          quickAddGuidedLastSignature = 'unsupported';
          guidedEls.root.hidden = true;
          guidedEls.fields.innerHTML = '';
          setQuickAddNativeVisibility(guidedEls.native, false);
          return false;
        }

        var requiredModels = models.filter(function(model) { return model.required; });
        var requiredCompleteCount = requiredModels.filter(isQuickAddModelComplete).length;
        var stepText = buildQuickAddStepText(requiredModels, requiredCompleteCount);
        var hideNative = !hasNativeFallback;
        var nextSignature = buildQuickAddGuidedSignature(models, stepText, hideNative, selectionsSummary);
        if (nextSignature === quickAddGuidedLastSignature) return true;
        quickAddGuidedLastSignature = nextSignature;

        guidedEls.root.hidden = false;
        setQuickAddNativeVisibility(guidedEls.native, hideNative);
        guidedEls.fields.innerHTML = '';
        setQuickAddSelectionsSummary(selectionsSummary);
        if (guidedEls.progress) {
          guidedEls.progress.hidden = !stepText;
          guidedEls.progress.textContent = stepText;
        }

        var firstPendingRequiredIndex = -1;
        for (var pendingIndex = 0; pendingIndex < models.length; pendingIndex += 1) {
          if (models[pendingIndex].required && !isQuickAddModelComplete(models[pendingIndex])) {
            firstPendingRequiredIndex = pendingIndex;
            break;
          }
        }

        models.forEach(function(model, modelIndex) {
          var modelHasSelection = normalizeQuickAddFieldText(readQuickAddControlValue(model.control)) !== '';
          var modelIsComplete = Boolean(model.required && isQuickAddModelComplete(model));
          var cardEl = document.createElement('section');
          cardEl.className = 'hd-quick-add__guided-card';
          cardEl.classList.add('hd-quick-add__guided-card--tone-' + String((modelIndex % 5) + 1));
          if (modelHasSelection) cardEl.classList.add('is-selected');
          if (modelIsComplete) cardEl.classList.add('is-complete');
          if (firstPendingRequiredIndex === modelIndex) cardEl.classList.add('is-active');

          var titleEl = document.createElement('div');
          titleEl.className = 'hd-quick-add__guided-title';

          var titleMainEl = document.createElement('div');
          titleMainEl.className = 'hd-quick-add__guided-title-main';

          var stepEl = document.createElement('span');
          stepEl.className = 'hd-quick-add__guided-step';
          stepEl.textContent = modelHasSelection ? '✓' : String(modelIndex + 1);
          titleMainEl.appendChild(stepEl);

          var labelEl = document.createElement('h3');
          labelEl.className = 'hd-quick-add__guided-label';
          labelEl.textContent = model.label;
          if (model.required) {
            var requiredEl = document.createElement('span');
            requiredEl.className = 'hd-quick-add__guided-required';
            requiredEl.textContent = '*';
            labelEl.appendChild(requiredEl);
          }
          titleMainEl.appendChild(labelEl);
          titleEl.appendChild(titleMainEl);

          var titleMetaEl = document.createElement('div');
          titleMetaEl.className = 'hd-quick-add__guided-title-meta';
          if (model.type === 'select') {
            var countEl = document.createElement('span');
            countEl.className = 'hd-quick-add__guided-choice-count';
            countEl.textContent = model.choices.length + (model.choices.length === 1 ? ' choice' : ' choices');
            titleMetaEl.appendChild(countEl);
          }
          if (modelHasSelection) {
            var selectedTagEl = document.createElement('span');
            selectedTagEl.className = 'hd-quick-add__guided-selected-tag';
            if (model.required && !modelIsComplete) {
              selectedTagEl.classList.add('is-partial');
              selectedTagEl.textContent = '◔ In progress';
            } else {
              selectedTagEl.classList.add('is-complete');
              selectedTagEl.textContent = '✓ Selected';
            }
            titleMetaEl.appendChild(selectedTagEl);
          }
          if (titleMetaEl.children.length > 0) titleEl.appendChild(titleMetaEl);

          cardEl.appendChild(titleEl);

          if (model.type === 'select') {
            if (model.choices.length === 0) {
              var waitingHelpEl = document.createElement('p');
              waitingHelpEl.className = 'hd-quick-add__guided-help';
              waitingHelpEl.textContent = 'Waiting for available choices...';
              cardEl.appendChild(waitingHelpEl);
            } else if (model.mode === 'chips') {
              var chipGridEl = document.createElement('div');
              chipGridEl.className = 'hd-quick-add__guided-chip-grid';
              model.choices.forEach(function(choice) {
                var chipEl = document.createElement('button');
                chipEl.type = 'button';
                chipEl.className = 'hd-quick-add__guided-chip';
                if (model.value === choice.value) chipEl.classList.add('is-selected');
                chipEl.setAttribute('aria-pressed', model.value === choice.value ? 'true' : 'false');
                chipEl.textContent = choice.label;
                chipEl.setAttribute('data-hd-guided-choice', choice.value);
                chipEl.addEventListener('click', function() {
                  var isSameChoice = String(model.value || '') === String(choice.value || '');
                  var nextValue = (!model.required && isSameChoice) ? '' : choice.value;
                  setQuickAddControlValue(model.control, nextValue);
                  scheduleQuickAddGuidedRender(requestToken);
                });
                chipGridEl.appendChild(chipEl);
              });
              cardEl.appendChild(chipGridEl);
              if (!model.required && modelHasSelection) {
                var clearHintEl = document.createElement('p');
                clearHintEl.className = 'hd-quick-add__guided-help';
                clearHintEl.textContent = 'Tap selected option again to clear.';
                cardEl.appendChild(clearHintEl);
              }
            } else {
              var selectEl = document.createElement('select');
              selectEl.className = 'hd-quick-add__guided-select';
              selectEl.setAttribute('aria-label', model.label);
              var placeholderEl = document.createElement('option');
              placeholderEl.value = '';
              placeholderEl.textContent = '-- Please Select --';
              selectEl.appendChild(placeholderEl);
              model.choices.forEach(function(choice) {
                var optionEl = document.createElement('option');
                optionEl.value = choice.value;
                optionEl.textContent = choice.label;
                selectEl.appendChild(optionEl);
              });
              selectEl.value = model.value || '';
              if (model.value) selectEl.classList.add('is-selected');
              selectEl.addEventListener('change', function() {
                if (selectEl.value) {
                  selectEl.classList.add('is-selected');
                } else {
                  selectEl.classList.remove('is-selected');
                }
                setQuickAddControlValue(model.control, selectEl.value || '');
                scheduleQuickAddGuidedRender(requestToken);
              });
              cardEl.appendChild(selectEl);
            }
          } else if (model.type === 'textarea') {
            var isOptional = !model.required;
            var textareaEl = document.createElement('textarea');
            textareaEl.className = 'hd-quick-add__guided-textarea';
            textareaEl.setAttribute('data-hd-guided-option-id', model.id);
            textareaEl.value = model.value || '';
            textareaEl.placeholder = isOptional ? 'Add an optional note' : '';
            textareaEl.addEventListener('change', function() {
              setQuickAddControlValue(model.control, textareaEl.value || '', 'change');
              scheduleQuickAddGuidedRender(requestToken);
            });
            textareaEl.addEventListener('blur', function() {
              setQuickAddControlValue(model.control, textareaEl.value || '', 'change');
              scheduleQuickAddGuidedRender(requestToken);
            });
            textareaEl.addEventListener('focus', function() {
              var detailsParentEl = textareaEl.closest('details');
              if (detailsParentEl) detailsParentEl.open = true;
            });

            if (isOptional) {
              var detailsEl = document.createElement('details');
              detailsEl.className = 'hd-quick-add__guided-note';
              if (normalizeQuickAddFieldText(model.value)) detailsEl.open = true;
              var summaryEl = document.createElement('summary');
              summaryEl.textContent = model.label + ' (optional)';
              var detailsBodyEl = document.createElement('div');
              detailsBodyEl.className = 'hd-quick-add__guided-note-body';
              detailsBodyEl.appendChild(textareaEl);
              detailsEl.appendChild(summaryEl);
              detailsEl.appendChild(detailsBodyEl);
              cardEl.appendChild(detailsEl);
            } else {
              cardEl.appendChild(textareaEl);
            }
          } else {
            var nativeHelpEl = document.createElement('p');
            nativeHelpEl.className = 'hd-quick-add__guided-help';
            nativeHelpEl.textContent = 'This option uses the original field layout.';
            cardEl.appendChild(nativeHelpEl);
          }

          if (model.required && !isQuickAddModelComplete(model)) {
            var helpEl = document.createElement('p');
            helpEl.className = 'hd-quick-add__guided-help is-error';
            helpEl.textContent = model.requiredHelp || ('"' + model.label + '" is required');
            cardEl.appendChild(helpEl);
          }

          guidedEls.fields.appendChild(cardEl);
        });

        return true;
      }

      function scheduleQuickAddGuidedRender(requestToken) {
        clearQuickAddGuidedRenderTimer();
        quickAddGuidedRenderTimer = window.setTimeout(function() {
          quickAddGuidedRenderTimer = null;
          if (requestToken && requestToken !== quickAddCurrentToken) return;
          try {
            renderQuickAddGuidedUi(requestToken);
          } catch (error) {
            var guidedEls = getQuickAddGuidedElements();
            if (guidedEls && guidedEls.root) guidedEls.root.hidden = true;
            if (guidedEls) setQuickAddNativeVisibility(guidedEls.native, false);
          }
        }, 55);
      }

      function startQuickAddGuidedUi(requestToken) {
        disconnectQuickAddGuidedObserver();
        clearQuickAddGuidedRenderTimer();
        scheduleQuickAddGuidedRender(requestToken);
        if (!quickAddMountEl || typeof window.MutationObserver !== 'function') return;

        quickAddGuidedObserver = new MutationObserver(function(mutations) {
          if (requestToken && requestToken !== quickAddCurrentToken) return;
          if (!shouldRebuildGuidedFromMutations(mutations)) return;
          scheduleQuickAddGuidedRender(requestToken);
        });

        quickAddGuidedObserver.observe(quickAddMountEl, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'disabled']
        });
      }

      function renderQuickAddLoadingSkeleton() {
        if (!quickAddMountEl) return;
        quickAddGuidedLastSignature = '';
        quickAddMountEl.innerHTML = ''
          + '<div class="hd-quick-add__skeleton" aria-hidden="true">'
          + '<div class="hd-quick-add__skeleton-line hd-quick-add__skeleton-line--short"></div>'
          + '<div class="hd-quick-add__skeleton-block"></div>'
          + '<div class="hd-quick-add__skeleton-line hd-quick-add__skeleton-line--mid"></div>'
          + '<div class="hd-quick-add__skeleton-block"></div>'
          + '<div class="hd-quick-add__skeleton-line hd-quick-add__skeleton-line--full"></div>'
          + '</div>';
      }

      function warmQuickAddVisibleHandles(limitCount) {
        if (!cardsContainer) return;
        var triggers = Array.prototype.slice.call(cardsContainer.querySelectorAll('[data-hd-quick-add-trigger]'));
        if (triggers.length === 0) return;
        var limit = Math.max(1, Number(parseInt(limitCount, 10) || 8));
        var warmedCount = 0;
        for (var i = 0; i < triggers.length; i += 1) {
          if (warmedCount >= limit) break;
          var trigger = triggers[i];
          if (!trigger || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') continue;
          var handle = String(trigger.getAttribute('data-hd-product-handle') || '').trim().toLowerCase();
          if (!handle || quickAddWarmHandles[handle]) continue;
          quickAddWarmHandles[handle] = true;
          warmedCount += 1;
          fetchQuickAddProduct(handle).catch(function() {});
        }
      }

      function scheduleQuickAddWarmup() {
        if (quickAddWarmupTimer) {
          window.clearTimeout(quickAddWarmupTimer);
          quickAddWarmupTimer = null;
        }
        quickAddWarmupTimer = window.setTimeout(function() {
          quickAddWarmupTimer = null;
          var runWarmup = function() {
            warmQuickAddVisibleHandles(10);
            if (!quickAddWarmupRequested) {
              quickAddWarmupRequested = true;
              waitForMwApoReady(2200).catch(function() {});
            }
          };
          if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(function() { runWarmup(); }, { timeout: 1000 });
          } else {
            runWarmup();
          }
        }, 120);
      }

      function closeQuickAddModal() {
        if (!quickAddModalEl || !quickAddModalEl.classList.contains('is-open')) return;
        quickAddCurrentToken += 1;
        quickAddActiveProductId = '';
        disconnectQuickAddObserver();
        disconnectQuickAddGuidedObserver();
        clearQuickAddGuidedRenderTimer();
        clearQuickAddNoOptionsTimer();
        quickAddGuidedLastSignature = '';
        if (quickAddMountEl) quickAddMountEl.innerHTML = '';
        quickAddModalEl.classList.remove('is-open');
        quickAddModalEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hd-quick-add-open');
        clearQuickAddStatusTone();
        if (quickAddStatusEl) quickAddStatusEl.textContent = 'Preparing product options...';
        setQuickAddTitle('Product');
        if (quickAddOpenProductEl) quickAddOpenProductEl.setAttribute('href', '/collections/all');
        var imgEl = document.getElementById('HdQuickAddImage');
        if (imgEl) { imgEl.setAttribute('src', ''); imgEl.setAttribute('alt', ''); }
        if (quickAddLastFocusedEl && typeof quickAddLastFocusedEl.focus === 'function') {
          quickAddLastFocusedEl.focus();
        }
        quickAddLastFocusedEl = null;
      }

      function openQuickAddModal(productTitle, productUrl, productImage) {
        if (!quickAddModalEl || !quickAddDialogEl) return;
        quickAddModalEl.classList.add('is-open');
        quickAddModalEl.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hd-quick-add-open');
        setQuickAddTitle(productTitle);
        if (quickAddOpenProductEl) quickAddOpenProductEl.setAttribute('href', normalizeQuickAddUrl(productUrl, ''));
        var imgEl = document.getElementById('HdQuickAddImage');
        if (imgEl) {
          imgEl.setAttribute('src', productImage || '');
          imgEl.setAttribute('alt', productTitle || '');
        }
        window.setTimeout(function() {
          quickAddDialogEl.focus();
        }, 20);
      }

      function waitForMwApoReady(timeoutMs) {
        return new Promise(function(resolve, reject) {
          var startedAt = Date.now();

          function check() {
            if (window.mwApoInit && window.mwApoInit.apo && typeof window.mwApoInit.apo.initInlineHelpers === 'function') {
              resolve(window.mwApoInit);
              return;
            }
            if (Date.now() - startedAt >= timeoutMs) {
              reject(new Error('quick add init timeout'));
              return;
            }
            window.setTimeout(check, 70);
          }

          check();
        });
      }

      function readQuickAddData(triggerEl) {
        if (!triggerEl) return null;
        var productId = Number(parseInt(triggerEl.getAttribute('data-hd-product-id') || '0', 10) || 0);
        var variantId = Number(parseInt(triggerEl.getAttribute('data-hd-variant-id') || '0', 10) || 0);
        var productHandle = String(triggerEl.getAttribute('data-hd-product-handle') || '').trim();
        if (!productId || !variantId || !productHandle) return null;

        return {
          productId: productId,
          variantId: variantId,
          productHandle: productHandle,
          productTitle: String(triggerEl.getAttribute('data-hd-product-title') || '').trim(),
          productUrl: normalizeQuickAddUrl(triggerEl.getAttribute('data-hd-product-url'), productHandle),
          productPrice: Number(parseInt(triggerEl.getAttribute('data-hd-product-price') || '0', 10) || 0),
          productComparePrice: Number(parseInt(triggerEl.getAttribute('data-hd-product-compare-price') || '0', 10) || 0),
          productImage: String(triggerEl.getAttribute('data-hd-product-image') || '').trim()
        };
      }

      function fetchQuickAddProduct(handle) {
        var key = String(handle || '').trim().toLowerCase();
        if (!key) return Promise.reject(new Error('missing product handle'));
        if (quickAddProductCache[key]) return Promise.resolve(quickAddProductCache[key]);

        return fetch('/products/' + encodeURIComponent(key) + '.js', {
          credentials: 'same-origin'
        })
          .then(function(response) {
            if (!response.ok) throw new Error('quick add product fetch failed');
            return response.json();
          })
          .then(function(productData) {
            if (!productData || typeof productData !== 'object') {
              throw new Error('invalid product data');
            }
            quickAddProductCache[key] = productData;
            return productData;
          });
      }

      function findQuickAddVariant(productData, preferredVariantId) {
        if (!productData || !Array.isArray(productData.variants) || productData.variants.length === 0) return null;
        var preferredId = Number(parseInt(preferredVariantId, 10) || 0);
        var match = null;

        if (preferredId) {
          match = productData.variants.find(function(variant) {
            return Number(parseInt(variant.id, 10) || 0) === preferredId;
          });
        }
        if (match) return match;

        match = productData.variants.find(function(variant) {
          return Boolean(variant && variant.available);
        });
        return match || productData.variants[0];
      }

      function renderQuickAddForm(productData, cardData, variantData) {
        if (!quickAddMountEl) return null;
        var variantId = Number(parseInt(variantData && variantData.id, 10) || 0);
        var basePrice = Number(parseInt((variantData && variantData.price) || cardData.productPrice || 0, 10) || 0);
        var comparePrice = Number(parseInt((variantData && variantData.compare_at_price) || cardData.productComparePrice || 0, 10) || 0);
        var priceHtml = formatQuickAddMoney(basePrice);
        if (comparePrice > basePrice) {
          priceHtml = '<s>' + escapeHtml(formatQuickAddMoney(comparePrice)) + '</s> ' + escapeHtml(formatQuickAddMoney(basePrice));
        } else {
          priceHtml = escapeHtml(formatQuickAddMoney(basePrice));
        }

        quickAddMountEl.innerHTML = ''
          + '<form class="hd-quick-add__form" action="/cart/add" method="post" novalidate>'
          + '<input type="hidden" name="id" value="' + variantId + '">'
          + '<input type="hidden" name="quantity" value="1">'
          + '<p class="hd-quick-add__price" id="HdQuickAddPrice">' + priceHtml + '</p>'
          + '<div class="hd-quick-add__guided" data-hd-quick-add-guided hidden>'
          + '<p class="hd-quick-add__guided-progress" data-hd-quick-add-guided-progress hidden></p>'
          + '<div class="hd-quick-add__guided-fields" data-hd-quick-add-guided-fields></div>'
          + '</div>'
          + '<span class="hd-quick-add__options hd-quick-add__options--native"'
          + ' data-hd-quick-add-options'
          + ' data-mw-apo-init="' + Number(parseInt(productData.id, 10) || 0) + '"'
          + ' data-mw-apo-variant-id="' + variantId + '"'
          + ' data-mw-apo-s-container="#HdQuickAddDialog"'
          + ' data-mw-apo-s-add-to-cart=".hd-quick-add__submit"'
          + ' data-mw-apo-s-price="#HdQuickAddPrice"'
          + ' data-mw-apo-s-form=".hd-quick-add__form"'
          + ' data-mw-apo-s-variants="input[name=\'id\']"'
          + ' data-mw-apo-s-quantity="input[name=\'quantity\']"'
          + '></span>'
          + '<div class="hd-quick-add__actions" data-hd-quick-add-actions>'
          + '<p class="hd-quick-add__basic-hint" data-hd-quick-add-basic-hint hidden>No custom options needed. Add this item directly to cart.</p>'
          + '<p class="hd-quick-add__selection-bar" aria-live="polite" aria-atomic="true">'
          + '<span class="hd-quick-add__selection-label">Selections:</span>'
          + '<span class="hd-quick-add__selection-value" data-hd-quick-add-selection-value>Tap an option below to get started</span>'
          + '</p>'
          + '<div class="hd-quick-add__quantity">'
          + '<span class="hd-quick-add__quantity-label">Quantity</span>'
          + '<div class="hd-quick-add__quantity-control">'
          + '<button type="button" class="hd-quick-add__quantity-btn" data-hd-qty-minus aria-label="Decrease quantity">\u2212</button>'
          + '<span class="hd-quick-add__quantity-value" data-hd-qty-display>1</span>'
          + '<button type="button" class="hd-quick-add__quantity-btn" data-hd-qty-plus aria-label="Increase quantity">+</button>'
          + '</div>'
          + '</div>'
          + '<button type="submit" name="add" class="hd-quick-add__submit" data-add-to-cart aria-label="Add to cart" data-hd-variant-id="' + variantId + '" disabled>Add to cart</button>'
          + '</div>'
          + '</form>';

        var optionsRoot = quickAddMountEl.querySelector('[data-hd-quick-add-options]');
        if (optionsRoot) {
          optionsRoot.setAttribute('data-mw-product', JSON.stringify(productData));
        }
        setQuickAddBasicMode(false, { buttonLabel: 'Add to cart' });
        return quickAddMountEl.querySelector('.hd-quick-add__submit');
      }

      function observeQuickAddMount(token) {
        disconnectQuickAddObserver();
        if (!quickAddMountEl || typeof window.MutationObserver !== 'function') return;

        quickAddModalObserver = new MutationObserver(function() {
          if (token !== quickAddCurrentToken) return;
          if (!quickAddModalEl || !quickAddModalEl.classList.contains('is-open')) return;
          var optionsContainer = quickAddMountEl.querySelector('.mw-apo-container, .mw-options-container');
          if (!optionsContainer) return;
          clearQuickAddNoOptionsTimer();
          setQuickAddStatus('Choose required options and add to cart.');
          var submitButton = quickAddMountEl.querySelector('.hd-quick-add__submit');
          if (submitButton) submitButton.removeAttribute('disabled');
          startQuickAddGuidedUi(token);
          disconnectQuickAddObserver();
        });

        quickAddModalObserver.observe(quickAddMountEl, {
          childList: true,
          subtree: true
        });
      }

      function handleQuickAddMwEvent(eventName) {
        if (!quickAddModalEl || !quickAddModalEl.classList.contains('is-open')) return;
        var submitButton = quickAddMountEl ? quickAddMountEl.querySelector('.hd-quick-add__submit') : null;

        if (eventName === 'init::insertIntoInline::afterHtmlInserted' || eventName === 'init::finish') {
          if (isQuickAddBasicMode()) {
            if (submitButton) submitButton.removeAttribute('disabled');
            return;
          }
          setQuickAddStatus('Choose required options and add to cart.');
          if (submitButton) submitButton.removeAttribute('disabled');
          scheduleQuickAddGuidedRender(quickAddCurrentToken);
          return;
        }

        if (eventName === 'initialize::no::options::for::product') {
          clearQuickAddNoOptionsTimer();
          disconnectQuickAddObserver();
          disconnectQuickAddGuidedObserver();
          clearQuickAddGuidedRenderTimer();
          setQuickAddStatus('No custom options needed. Add this item directly to cart.', 'success');
          if (submitButton) {
            submitButton.removeAttribute('disabled');
          }
          setQuickAddBasicMode(true, { buttonLabel: 'Add to cart' });
          return;
        }

        if (eventName === 'initialize::variant::not::available') {
          setQuickAddStatus('This variant is currently unavailable.', 'error');
          if (submitButton) submitButton.setAttribute('disabled', 'disabled');
          return;
        }

        if (eventName === 'attachEvents::initAddToCart::clickStart') {
          syncQuickAddTextareaControls();
          setQuickAddStatus('Adding to cart...');
          if (submitButton) submitButton.setAttribute('disabled', 'disabled');
          return;
        }

        if (eventName === 'attachEvents::initAddToCart::clickEnd') {
          setQuickAddStatus('Finalizing cart...');
          return;
        }

        if (eventName === 'attachEvents::initAddToCart::clickError' || eventName === 'onClick::validate-failed') {
          if (isQuickAddBasicMode()) {
            setQuickAddStatus('Could not add this product right now. Try again.', 'error');
          } else {
            setQuickAddStatus('Please complete required options before adding to cart.', 'error');
          }
          if (submitButton) submitButton.removeAttribute('disabled');
          return;
        }

        if (eventName === 'attachEvents::initAddToCart::clickFinally') {
          var formEl = quickAddMountEl ? quickAddMountEl.querySelector('.hd-quick-add__form') : null;
          var isSubmitting = Boolean(formEl && formEl.getAttribute('data-hd-submitting') === 'true');
          if (submitButton && !isSubmitting) submitButton.removeAttribute('disabled');
          if (!isQuickAddBasicMode()) scheduleQuickAddGuidedRender(quickAddCurrentToken);
        }
      }

      function hookQuickAddMwEvents() {
        if (quickAddEventsHooked) return;
        if (!window.mwApoInit) return;

        quickAddOriginalMwOnEvent = typeof window.mwApoInit.onEvent === 'function' ? window.mwApoInit.onEvent : null;
        window.mwApoInit.onEvent = function(eventName, payload) {
          try {
            handleQuickAddMwEvent(eventName, payload);
          } catch (error) {}

          if (quickAddOriginalMwOnEvent) {
            try {
              quickAddOriginalMwOnEvent.call(window.mwApoInit, eventName, payload);
            } catch (error) {}
          }
        };
        quickAddEventsHooked = true;
      }

      function configureQuickAddMwForCollection() {
        if (!window.mwApoInit || !window.mwApoInit.settings) return;
        var betaFeatures = window.mwApoInit.settings.beta_features;
        if (!betaFeatures) {
          betaFeatures = {};
          window.mwApoInit.settings.beta_features = betaFeatures;
        }
        if (quickAddSyncInventoryOriginal === null) {
          quickAddSyncInventoryOriginal = betaFeatures.sync_inventory;
        }
        betaFeatures.sync_inventory = 'no';
      }

      function startQuickAddInline(productData, cardData, token) {
        if (!window.mwApoInit || !window.mwApoInit.apo || typeof window.mwApoInit.apo.initInlineHelpers !== 'function') {
          throw new Error('quick add app not ready');
        }
        if (token !== quickAddCurrentToken) return;

        hookQuickAddMwEvents();
        configureQuickAddMwForCollection();
        window.mwApoInit.product = productData;
        window.mwApoInit.template_name = 'collection';
        window.mwApoInit.response = window.mwApoInit.response || {};
        quickAddActiveProductId = String(Number(parseInt(productData.id, 10) || 0));
        observeQuickAddMount(token);
        startQuickAddGuidedUi(token);
        scheduleQuickAddNoOptionsFallback(token);
        window.mwApoInit.apo.initInlineHelpers(window.mwApoInit);
      }

      function addQuickAddVariantDirectly(variantId, submitButton) {
        var safeVariantId = Number(parseInt(variantId, 10) || 0);
        if (!safeVariantId) return;
        if (submitButton) submitButton.setAttribute('disabled', 'disabled');
        setQuickAddStatus('Adding to cart...');

        var qtyInput = quickAddMountEl ? quickAddMountEl.querySelector('input[name="quantity"]') : null;
        var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10) || 1);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: safeVariantId,
            quantity: quantity
          })
        })
          .then(function(response) {
            if (!response.ok) throw new Error('quick add fallback failed');
            return response.json();
          })
          .then(function() {
            setQuickAddStatus('\u2713 Added to cart!', 'success');
            queueCartCountRefresh(220);
            document.dispatchEvent(new Event('cart:refresh'));
            window.setTimeout(function() {
              closeQuickAddModal();
            }, 1400);
          })
          .catch(function() {
            setQuickAddStatus('Could not add this product right now. Use full product page.', 'error');
            if (submitButton) submitButton.removeAttribute('disabled');
          });
      }

      function parseQuickAddAddErrorMessage(payload) {
        if (!payload || typeof payload !== 'object') {
          return 'Could not add this product right now. Try again.';
        }
        if (payload.description) return String(payload.description);
        if (payload.message) return String(payload.message);
        if (!payload.errors) return 'Could not add this product right now. Try again.';
        if (typeof payload.errors === 'string') return payload.errors;
        var errorKeys = Object.keys(payload.errors);
        if (errorKeys.length === 0) return 'Could not add this product right now. Try again.';
        var firstError = payload.errors[errorKeys[0]];
        if (Array.isArray(firstError) && firstError.length > 0) return String(firstError[0]);
        if (firstError) return String(firstError);
        return 'Could not add this product right now. Try again.';
      }

      function submitQuickAddForm(formEl, submitButton) {
        if (!formEl || typeof fetch !== 'function') return;
        if (formEl.getAttribute('data-hd-submitting') === 'true') return;
        syncQuickAddTextareaControls();
        formEl.setAttribute('data-hd-submitting', 'true');
        if (submitButton) submitButton.setAttribute('disabled', 'disabled');
        setQuickAddStatus('Adding to cart...');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          },
          body: new FormData(formEl)
        })
          .then(function(response) {
            var isJson = String(response.headers.get('content-type') || '').indexOf('application/json') !== -1;
            if (!isJson) {
              if (!response.ok) throw new Error('Could not add this product right now. Try again.');
              return null;
            }
            return response.json().then(function(payload) {
              if (!response.ok) {
                throw new Error(parseQuickAddAddErrorMessage(payload));
              }
              return payload;
            });
          })
          .then(function() {
            setQuickAddStatus('\u2713 Added to cart!', 'success');
            document.dispatchEvent(new Event('cart:refresh'));
            window.dispatchEvent(new Event('cart-item-added'));
            refreshCartCountFromStore();
            window.setTimeout(function() {
              closeQuickAddModal();
            }, 1400);
          })
          .catch(function(error) {
            var message = error && error.message ? error.message : 'Could not add this product right now. Try again.';
            setQuickAddStatus(message, 'error');
            if (submitButton) submitButton.removeAttribute('disabled');
          })
          .finally(function() {
            formEl.removeAttribute('data-hd-submitting');
          });
      }

      function openQuickAddFromTrigger(triggerEl) {
        var cardData = readQuickAddData(triggerEl);
        if (!cardData) return;

        quickAddCurrentToken += 1;
        var requestToken = quickAddCurrentToken;
        disconnectQuickAddObserver();
        disconnectQuickAddGuidedObserver();
        clearQuickAddGuidedRenderTimer();
        clearQuickAddNoOptionsTimer();
        quickAddGuidedLastSignature = '';
        quickAddLastFocusedEl = document.activeElement;
        renderQuickAddLoadingSkeleton();
        setQuickAddStatus('Preparing product options...');
        openQuickAddModal(cardData.productTitle || 'Product', cardData.productUrl, cardData.productImage);

        Promise.all([
          waitForMwApoReady(6000),
          fetchQuickAddProduct(cardData.productHandle)
        ])
          .then(function(results) {
            if (requestToken !== quickAddCurrentToken) return;
            var productData = results[1];
            var variantData = findQuickAddVariant(productData, cardData.variantId);
            if (!variantData) throw new Error('quick add variant not found');
            var submitButton = renderQuickAddForm(productData, cardData, variantData);
            if (submitButton) submitButton.setAttribute('disabled', 'disabled');
            setQuickAddStatus('Loading option fields...');
            startQuickAddInline(productData, cardData, requestToken);
          })
          .catch(function() {
            if (requestToken !== quickAddCurrentToken) return;
            clearQuickAddNoOptionsTimer();
            setQuickAddStatus('Quick add is unavailable for this item right now. Open full product page.', 'error');
          });
      }

      function setupQuickAddModal() {
        if (!cardsContainer || !quickAddModalEl || !quickAddDialogEl || !quickAddMountEl) return;

        cardsContainer.addEventListener('click', function(event) {
          var trigger = event.target.closest('[data-hd-quick-add-trigger]');
          if (!trigger) return;
          event.preventDefault();
          event.stopPropagation();
          openQuickAddFromTrigger(trigger);
        }, true);

        quickAddModalEl.addEventListener('click', function(event) {
          var closeTarget = event.target.closest('[data-hd-quick-add-close]');
          if (!closeTarget) return;
          event.preventDefault();
          closeQuickAddModal();
        });

        quickAddMountEl.addEventListener('click', function(event) {
          var submitTarget = event.target.closest('.hd-quick-add__submit');
          if (submitTarget) syncQuickAddTextareaControls();

          var basicSubmit = event.target.closest('.hd-quick-add__submit[data-hd-basic-add="true"]');
          if (!basicSubmit) return;
          event.preventDefault();
          var variantId = Number(parseInt(basicSubmit.getAttribute('data-hd-variant-id') || '0', 10) || 0);
          addQuickAddVariantDirectly(variantId, basicSubmit);
        });

        quickAddMountEl.addEventListener('submit', function(event) {
          var formEl = event.target;
          if (!formEl || !formEl.matches || !formEl.matches('.hd-quick-add__form')) return;
          syncQuickAddTextareaControls();
          var submitButton = formEl.querySelector('.hd-quick-add__submit');
          if (submitButton && submitButton.getAttribute('data-hd-basic-add') === 'true') {
            event.preventDefault();
            var basicVariantId = Number(parseInt(submitButton.getAttribute('data-hd-variant-id') || '0', 10) || 0);
            addQuickAddVariantDirectly(basicVariantId, submitButton);
            return;
          }
          event.preventDefault();
          submitQuickAddForm(formEl, submitButton);
        });

        quickAddMountEl.addEventListener('click', function(event) {
          var minusBtn = event.target.closest('[data-hd-qty-minus]');
          var plusBtn = event.target.closest('[data-hd-qty-plus]');
          if (!minusBtn && !plusBtn) return;
          event.preventDefault();
          var qtyInput = quickAddMountEl.querySelector('input[name="quantity"]');
          var qtyDisplay = quickAddMountEl.querySelector('[data-hd-qty-display]');
          if (!qtyInput) return;
          var current = Math.max(1, parseInt(qtyInput.value, 10) || 1);
          if (minusBtn && current > 1) current -= 1;
          if (plusBtn && current < 10) current += 1;
          qtyInput.value = String(current);
          if (qtyDisplay) qtyDisplay.textContent = String(current);
        });

        document.addEventListener('keydown', function(event) {
          if (!quickAddModalEl.classList.contains('is-open')) return;
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeQuickAddModal();
        });

        scheduleQuickAddWarmup();
      }

      function isProductHref(href) {
        if (!href) return false;
        try {
          var url = new URL(href, window.location.origin);
          return url.origin === window.location.origin && url.pathname.indexOf('/products/') !== -1;
        } catch (error) {
          return href.indexOf('/products/') !== -1;
        }
      }

      function getCollectionStateKey(pathname) {
        return 'hd_collection_all_state_v1:' + pathname;
      }

      function serializeCollectionState() {
        return {
          path: window.location.pathname,
          query: window.location.search || '',
          sortValue: getActiveSortValue(),
          selectedColors: Array.from(selectedColors),
          selectedSizeKey: selectedSizeKey || '',
          searchText: searchQueryLabel || '',
          stockFilterActive: stockFilterActive,
          scrollY: Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0),
          timestamp: Date.now()
        };
      }

      function saveCollectionState() {
        try {
          window.sessionStorage.setItem(collectionStateKey, JSON.stringify(serializeCollectionState()));
        } catch (error) {}
      }

      function readCollectionState() {
        try {
          var rawState = window.sessionStorage.getItem(collectionStateKey);
          if (!rawState) return null;
          var parsed = JSON.parse(rawState);
          if (!parsed || typeof parsed !== 'object') return null;
          return parsed;
        } catch (error) {
          return null;
        }
      }

      function markCollectionReturnIntent() {
        try {
          window.sessionStorage.setItem(collectionReturnIntentKey, JSON.stringify({
            path: window.location.pathname,
            query: window.location.search || '',
            timestamp: Date.now()
          }));
        } catch (error) {}
      }

      function readCollectionReturnIntent() {
        try {
          var rawIntent = window.sessionStorage.getItem(collectionReturnIntentKey);
          if (!rawIntent) return null;
          var parsedIntent = JSON.parse(rawIntent);
          if (!parsedIntent || typeof parsedIntent !== 'object') return null;
          return parsedIntent;
        } catch (error) {
          return null;
        }
      }

      function clearCollectionReturnIntent() {
        try {
          window.sessionStorage.removeItem(collectionReturnIntentKey);
        } catch (error) {}
      }

      function shouldRestoreCollectionState(state) {
        if (!state || state.path !== window.location.pathname) return false;
        var ageMs = Date.now() - Number(state.timestamp || 0);
        if (!isFinite(ageMs) || ageMs > COLLECTION_STATE_MAX_AGE_MS) return false;

        var returnIntent = readCollectionReturnIntent();
        var hasFreshReturnIntent = false;
        if (returnIntent && returnIntent.path === window.location.pathname) {
          var intentAgeMs = Date.now() - Number(returnIntent.timestamp || 0);
          hasFreshReturnIntent = isFinite(intentAgeMs) && intentAgeMs >= 0 && intentAgeMs <= COLLECTION_STATE_MAX_AGE_MS;
        }
        if (hasFreshReturnIntent) return true;

        var navigationType = '';
        try {
          var navEntries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : [];
          if (navEntries && navEntries.length > 0) navigationType = navEntries[0].type || '';
        } catch (error) {}

        var referrerLooksLikeProduct = document.referrer &&
          document.referrer.indexOf(window.location.origin) === 0 &&
          document.referrer.indexOf('/products/') !== -1;

        return navigationType === 'back_forward' || navigationType === 'reload' || referrerLooksLikeProduct;
      }

      function applyCollectionStateSelections(state) {
        if (!state) return false;
        var sortChanged = false;
        var previousSortValue = getActiveSortValue();

        if (sortSelect && state.sortValue) {
          var hasSortOption = Array.prototype.slice.call(sortSelect.options).some(function(option) {
            return option.value === state.sortValue;
          });
          if (hasSortOption) {
            sortSelect.value = state.sortValue;
            sortChanged = state.sortValue !== previousSortValue;
          }
        }

        selectedColors.clear();
        if (Array.isArray(state.selectedColors)) {
          state.selectedColors.forEach(function(key) {
            if (colorIndex[key]) selectedColors.add(key);
          });
        }
        selectedSizeKey = '';
        if (isValidSizeSelectionKey(state.selectedSizeKey)) {
          selectedSizeKey = String(state.selectedSizeKey || '');
        }

        searchQueryLabel = String(state.searchText || '').replace(/\s+/g, ' ').trim();
        searchQuery = normalizeText(searchQueryLabel);
        searchTerms = searchQuery ? searchQuery.split(' ').filter(Boolean) : [];
        if (searchInputEl) searchInputEl.value = searchQueryLabel;

        stockFilterActive = Boolean(state.stockFilterActive);
        if (stockToggleEl) stockToggleEl.setAttribute('aria-pressed', stockFilterActive ? 'true' : 'false');

        syncSortChoiceState();
        renderFilter();
        updateDrawerButtons();
        return sortChanged;
      }

      function ensureScrollTargetReachable(targetY, remainingPageLoads) {
        var nextTargetY = Math.max(0, Number(targetY) || 0);
        if (nextTargetY <= 0) return Promise.resolve();
        var remainingLoads = typeof remainingPageLoads === 'number' ? remainingPageLoads : 60;
        var neededHeight = nextTargetY + (window.innerHeight || 800) + 140;
        var currentHeight = Math.max(
          document.documentElement ? document.documentElement.scrollHeight : 0,
          document.body ? document.body.scrollHeight : 0
        );

        if (currentHeight >= neededHeight) return Promise.resolve();
        if (remainingLoads <= 0 || !nextPageUrl) return Promise.resolve();

        return loadNextPage().then(function(didLoadPage) {
          if (!didLoadPage) return;
          return ensureScrollTargetReachable(nextTargetY, remainingLoads - 1);
        });
      }

      function restoreCollectionStateIfNeeded() {
        var storedState = readCollectionState();
        if (!shouldRestoreCollectionState(storedState)) return;

        clearCollectionReturnIntent();

        try {
          window.sessionStorage.removeItem(collectionStateKey);
        } catch (error) {}

        var sortChanged = applyCollectionStateSelections(storedState);
        var restorePromise = sortChanged ? replaceCardsForCurrentSort() : Promise.resolve();
        if (!restorePromise || typeof restorePromise.then !== 'function') {
          restorePromise = Promise.resolve();
        }

        restorePromise
          .then(function() {
            return ensureScrollTargetReachable(storedState.scrollY, 80);
          })
          .then(function() {
            var targetY = Math.max(0, Number(storedState.scrollY) || 0);
            if (targetY <= 0) return;
            window.scrollTo(0, targetY);
            window.setTimeout(function() {
              window.scrollTo(0, targetY);
            }, 90);
            saveCollectionState();
          })
          .catch(function() {
            saveCollectionState();
          });
      }

      function setupCollectionStatePersistence() {
        if (!cardsContainer) return;
        cardsContainer.addEventListener('click', function(event) {
          var link = event.target.closest('a[href]');
          if (!link) return;
          if (!link.closest('[data-hd-product-card]')) return;
          if (!isProductHref(link.getAttribute('href'))) return;
          saveCollectionState();
          markCollectionReturnIntent();
        });

        var scrollSaveTimer = null;
        window.addEventListener('scroll', function() {
          if (scrollSaveTimer) return;
          scrollSaveTimer = window.setTimeout(function() {
            scrollSaveTimer = null;
            saveCollectionState();
          }, 260);
        }, { passive: true });

        window.addEventListener('pagehide', saveCollectionState);
      }

      // League chips (snippets/hd-collection-subnav.liquid) stay plain links. On a same-tab tap, the shopper's current choices
      // (colours, size, search, In Stock, sort) are written into the destination page's own restore slot (state + return intent),
      // so restoreCollectionStateIfNeeded() opens the league page with them applied. The destination starts at the top, and a
      // sort that is only this page's default is not carried, so the destination keeps its own default.
      function buildCarriedCollectionState(state, destinationPath, destinationQuery, sourceDefaultSort) {
        var carried = {};
        Object.keys(state || {}).forEach(function(field) {
          carried[field] = state[field];
        });
        carried.path = destinationPath;
        carried.query = destinationQuery || '';
        carried.scrollY = 0;
        if (!carried.sortValue || carried.sortValue === sourceDefaultSort) carried.sortValue = '';
        return carried;
      }

      function carryCollectionStateToLeagueLink(link, event) {
        if (!link || !event || event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var linkTarget = String(link.getAttribute('target') || '').toLowerCase();
        if (linkTarget && linkTarget !== '_self') return;

        var destination;
        try {
          destination = new URL(link.href, window.location.origin);
        } catch (error) {
          return;
        }
        if (destination.origin !== window.location.origin) return;
        if (destination.pathname === window.location.pathname) return;

        // The chip's ?sort_by= was rendered with the page; the shopper may have changed the sort since (client-side).
        var sortValue = getActiveSortValue();
        if (sortValue && sortValue !== defaultSortValue) {
          destination.searchParams.set('sort_by', sortValue);
        } else {
          destination.searchParams.delete('sort_by');
        }
        link.setAttribute('href', destination.pathname + destination.search + destination.hash);

        var carriedState = buildCarriedCollectionState(serializeCollectionState(), destination.pathname, destination.search, defaultSortValue);
        var destinationKey = getCollectionStateKey(destination.pathname);
        try {
          window.sessionStorage.setItem(destinationKey, JSON.stringify(carriedState));
          window.sessionStorage.setItem(destinationKey + ':return_intent', JSON.stringify({
            path: carriedState.path,
            query: carriedState.query,
            timestamp: carriedState.timestamp
          }));
        } catch (error) {}
      }

      function setupLeagueNavCarryOver() {
        document.addEventListener('click', function(event) {
          var link = event.target && event.target.closest ? event.target.closest('.hd-league-nav__link[href]') : null;
          if (!link) return;
          carryCollectionStateToLeagueLink(link, event);
        });
      }

      function getStoredCollapseState() {
        try {
          var rawValue = window.localStorage.getItem('hd_collection_filter_collapsed');
          if (rawValue === '1') return true;
          if (rawValue === '0') return false;
        } catch (error) {}
        return null;
      }

      function setCollapsed(collapsed, persist) {
        filterRoot.classList.toggle('is-collapsed', collapsed);
        if (filterBodyEl) filterBodyEl.setAttribute('aria-hidden', collapsed ? 'true' : 'false');

        if (toggleEl) {
          toggleEl.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          var toggleLabelEl = toggleEl.querySelector('.hd-color-filter__toggle-label');
          if (toggleLabelEl) toggleLabelEl.textContent = collapsed ? 'Show' : 'Hide';
        }

        if (!persist) return;
        try {
          window.localStorage.setItem('hd_collection_filter_collapsed', collapsed ? '1' : '0');
        } catch (error) {}
      }

      function initializeCollapsedState() {
        setCollapsed(false, false);
      }

      function getStoredBrowseCollapseState() {
        try {
          var rawValue = window.localStorage.getItem('hd_collection_browse_collapsed');
          if (rawValue === '1') return true;
          if (rawValue === '0') return false;
        } catch (error) {}
        return null;
      }

      function setBrowseCollapsed(collapsed, persist) {
        if (!browsePanelEl) return;
        browsePanelEl.classList.toggle('is-collapsed', collapsed);

        if (browseBodyEl) browseBodyEl.setAttribute('aria-hidden', collapsed ? 'true' : 'false');

        if (browseToggleEl) {
          browseToggleEl.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          var browseToggleLabelEl = browseToggleEl.querySelector('.hd-browse-panel__toggle-label');
          if (browseToggleLabelEl) browseToggleLabelEl.textContent = collapsed ? 'Show' : 'Hide';
        }

        if (!persist) return;
        try {
          window.localStorage.setItem('hd_collection_browse_collapsed', collapsed ? '1' : '0');
        } catch (error) {}
      }

      function initializeBrowseCollapsedState() {
        if (!browsePanelEl) return;
        setBrowseCollapsed(false, false);
      }

      function setDrawerOpenState(targetId) {
        var drawerMap = {
          HdSortControl: sortControlEl,
          HdColorFilter: filterRoot,
          HdSearchPanel: searchPanelEl,
          HdBrowsePanel: browsePanelEl
        };

        Object.keys(drawerMap).forEach(function(id) {
          var drawerEl = drawerMap[id];
          if (!drawerEl) return;
          drawerEl.classList.toggle('is-open', targetId === id);
        });
      }

      function updateDrawerButtons() {
        if (!mainControlsEl) return;
        var buttons = Array.prototype.slice.call(mainControlsEl.querySelectorAll('[data-hd-drawer-target]'));
        buttons.forEach(function(button) {
          var buttonTargetId = button.getAttribute('data-hd-drawer-target');
          var isActive = buttonTargetId === activeDrawerId;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        var filterButton = mainControlsEl.querySelector('[data-hd-drawer-target="HdColorFilter"]');
        if (filterButton) filterButton.classList.toggle('has-selection', selectedColors.size > 0 || Boolean(selectedSizeKey));

        var searchButton = mainControlsEl.querySelector('[data-hd-drawer-target="HdSearchPanel"]');
        if (searchButton) searchButton.classList.toggle('has-selection', Boolean(searchQuery));

        var resetButton = mainControlsEl.querySelector('[data-hd-controls-action="reset"]');
        if (resetButton) {
          var hasCriteria = selectedColors.size > 0 || Boolean(selectedSizeKey) || Boolean(searchQuery) || stockFilterActive;
          resetButton.disabled = !hasCriteria;
          resetButton.classList.toggle('is-enabled', hasCriteria);
        }

        var closeButton = mainControlsEl.querySelector('[data-hd-controls-action="close-drawer"]');
        if (closeButton) {
          var hasOpenDrawer = Boolean(activeDrawerId);
          closeButton.disabled = !hasOpenDrawer;
          closeButton.classList.toggle('is-enabled', hasOpenDrawer);
        }

        updateControlsSummary();
      }

      function focusDrawerControl(targetId) {
        if (targetId === 'HdSortControl' && sortSelect) {
          setTimeout(function() {
            sortSelect.focus();
          }, 90);
        }

        if (targetId === 'HdSearchPanel' && searchInputEl) {
          setTimeout(function() {
            searchInputEl.focus();
          }, 90);
        }
      }

      function cancelDrawerAutoHideRaf() {
        if (!drawerAutoHideRaf) return;
        window.cancelAnimationFrame(drawerAutoHideRaf);
        drawerAutoHideRaf = null;
      }

      function cancelDrawerAutoHideTimer() {
        if (!drawerAutoHideTimer) return;
        window.clearTimeout(drawerAutoHideTimer);
        drawerAutoHideTimer = null;
      }

      function cancelDrawerAutoHideGraceTimer() {
        if (!drawerAutoHideGraceTimer) return;
        window.clearTimeout(drawerAutoHideGraceTimer);
        drawerAutoHideGraceTimer = null;
      }

      function queueDrawerAutoHideGraceCheck() {
        cancelDrawerAutoHideGraceTimer();
        var elapsed = Date.now() - drawerOpenedAtMs;
        var waitMs = Math.max(0, DRAWER_AUTO_HIDE_MIN_OPEN_MS - elapsed) + 20;
        drawerAutoHideGraceTimer = window.setTimeout(function() {
          drawerAutoHideGraceTimer = null;
          queueDrawerAutoHideCheck();
        }, waitMs);
      }

      function queueDrawerAutoHideClose() {
        cancelDrawerAutoHideTimer();
        drawerAutoHideTimer = window.setTimeout(function() {
          drawerAutoHideTimer = null;
          if (!activeDrawerId) return;
          closeActiveDrawer();
        }, DRAWER_AUTO_HIDE_SETTLE_MS);
      }

      function queueDrawerAutoHideCheck() {
        if (!activeDrawerId) return;
        if (drawerAutoHideRaf) return;
        drawerAutoHideRaf = window.requestAnimationFrame(function() {
          drawerAutoHideRaf = null;
          if (!activeDrawerId) return;

          var nowMs = Date.now();
          var currentScrollY = window.pageYOffset || 0;
          var scrollSinceOpen = currentScrollY - drawerOpenScrollY;
          var scrollSinceLast = currentScrollY - drawerLastScrollY;
          drawerLastScrollY = currentScrollY;

          if (scrollSinceLast >= DRAWER_AUTO_HIDE_DIRECTION_MIN_DELTA) {
            drawerAutoHideSawDownwardScroll = true;
          } else if (scrollSinceLast <= -DRAWER_AUTO_HIDE_DIRECTION_MIN_DELTA) {
            drawerAutoHideSawDownwardScroll = false;
          }

          // Ignore accidental scroll jitter immediately after opening a panel.
          if (nowMs - drawerOpenedAtMs < DRAWER_AUTO_HIDE_MIN_OPEN_MS) {
            cancelDrawerAutoHideTimer();
            if (scrollSinceOpen >= DRAWER_AUTO_HIDE_SCROLL_DELTA && drawerAutoHideSawDownwardScroll) {
              queueDrawerAutoHideGraceCheck();
            } else {
              cancelDrawerAutoHideGraceTimer();
            }
            return;
          }
          cancelDrawerAutoHideGraceTimer();

          // Close only when user is clearly scrolling down through the catalog.
          if (!drawerAutoHideSawDownwardScroll) {
            cancelDrawerAutoHideTimer();
            return;
          }
          if (scrollSinceOpen < DRAWER_AUTO_HIDE_SCROLL_DELTA) {
            cancelDrawerAutoHideTimer();
            return;
          }

          queueDrawerAutoHideClose();
        });
      }

      function closeActiveDrawer() {
        cancelDrawerAutoHideRaf();
        cancelDrawerAutoHideTimer();
        cancelDrawerAutoHideGraceTimer();
        if (!activeDrawerId) return;
        activeDrawerId = '';
        drawerOpenScrollY = 0;
        drawerOpenedAtMs = 0;
        drawerLastScrollY = 0;
        drawerAutoHideSawDownwardScroll = false;
        setDrawerOpenState('');
        updateDrawerButtons();
      }

      function toggleDrawer(targetId) {
        if (!targetId) return;
        cancelDrawerAutoHideRaf();
        cancelDrawerAutoHideTimer();
        cancelDrawerAutoHideGraceTimer();
        if (activeDrawerId === targetId) {
          closeActiveDrawer();
          return;
        }

        activeDrawerId = targetId;
        drawerOpenScrollY = window.pageYOffset || 0;
        drawerOpenedAtMs = Date.now();
        drawerLastScrollY = drawerOpenScrollY;
        drawerAutoHideSawDownwardScroll = false;
        setDrawerOpenState(targetId);
        updateDrawerButtons();
        focusDrawerControl(targetId);
      }

      function clearFilterSearchState(closeDrawers) {
        selectedColors.clear();
        selectedSizeKey = '';
        searchQuery = '';
        searchTerms = [];
        searchQueryLabel = '';
        stockFilterActive = false;
        if (stockToggleEl) stockToggleEl.setAttribute('aria-pressed', 'false');
        bumpCriteriaVersion();
        loadingAllPagesPromise = null;
        if (criteriaLoadTimer) {
          window.clearTimeout(criteriaLoadTimer);
          criteriaLoadTimer = null;
        }
        if (searchInputEl) searchInputEl.value = '';

        if (closeDrawers) {
          activeDrawerId = '';
          setDrawerOpenState('');
        }

        preloadAllPagesParallel();
        renderFilterAnimated();
        updateDrawerButtons();
        saveCollectionState();
      }

      function setupMainControls() {
        if (!mainControlsEl) return;
        mainControlsEl.addEventListener('click', function(event) {
          var actionButton = event.target.closest('[data-hd-controls-action]');
          if (actionButton) {
            event.preventDefault();
            var action = actionButton.getAttribute('data-hd-controls-action');
            if (action === 'reset') {
              clearFilterSearchState(true);
            } else if (action === 'close-drawer') {
              closeActiveDrawer();
            }
            return;
          }

          var button = event.target.closest('[data-hd-drawer-target]');
          if (!button) return;
          event.preventDefault();
          toggleDrawer(button.getAttribute('data-hd-drawer-target'));
        });

        if (drawerStackEl) {
          drawerStackEl.addEventListener('click', function(event) {
            var closeButton = event.target.closest('[data-hd-drawer-close]');
            if (!closeButton) return;
            event.preventDefault();
            closeActiveDrawer();
          });
        }

        document.addEventListener('keydown', function(event) {
          if (event.key !== 'Escape') return;
          closeActiveDrawer();
        });

        window.addEventListener('scroll', queueDrawerAutoHideCheck, { passive: true });

        if (stockToggleEl) {
          stockToggleEl.addEventListener('click', function() {
            stockFilterActive = !stockFilterActive;
            stockToggleEl.setAttribute('aria-pressed', stockFilterActive ? 'true' : 'false');
            bumpCriteriaVersion();
            preloadAllPagesParallel();
            renderFilterAnimated();
            saveCollectionState();
          });
        }
      }

      function setupMainControlsStickyState() {
        if (!mainControlsEl) return;
        var scrollRaf = null;
        var resizeTimer = null;
        var floatingStartY = 0;
        var announcementClass = 'hd-collection-announcement-collapsed';

        function setAnnouncementCollapsed(shouldCollapse) {
          if (!document.body) return;
          if (!mobileControlsMedia.matches) {
            document.body.classList.remove(announcementClass);
            return;
          }
          document.body.classList.toggle(announcementClass, shouldCollapse);
        }

        function getFloatingTop() {
          if (mobileControlsMedia.matches) return 4;
          return 10;
        }

        function syncFloatingGeometry() {
          var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
          var left = 12;
          var right = 12;

          if (!mobileControlsMedia.matches) {
            var collectionRect = collectionRoot.getBoundingClientRect();
            left = Math.max(8, Math.round(collectionRect.left));
            right = Math.max(8, Math.round(viewportWidth - collectionRect.right));

            if (viewportWidth > 0 && left + right > viewportWidth - 280) {
              var balancedInset = Math.max(8, Math.floor((viewportWidth - 280) / 2));
              left = balancedInset;
              right = balancedInset;
            }
          }

          var top = getFloatingTop();
          collectionRoot.style.setProperty('--hd-controls-floating-left', left + 'px');
          collectionRoot.style.setProperty('--hd-controls-floating-right', right + 'px');
          collectionRoot.style.setProperty('--hd-controls-floating-top', top + 'px');

          var controlsHeight = Math.round(mainControlsEl.getBoundingClientRect().height);
          if (controlsHeight > 0) {
            collectionRoot.style.setProperty('--hd-controls-floating-height', controlsHeight + 'px');
            if (mainControlsSpacerEl) mainControlsSpacerEl.style.height = (controlsHeight + 4) + 'px';
          }
        }

        function recalculateStickyStart() {
          mainControlsEl.classList.remove('is-floating');
          if (mainControlsSpacerEl) mainControlsSpacerEl.style.height = '0px';
          setAnnouncementCollapsed(false);
          syncFloatingGeometry();
          var rect = mainControlsEl.getBoundingClientRect();
          floatingStartY = window.pageYOffset + rect.top - getFloatingTop();
        }

        function applyStickyState() {
          var currentScrollY = window.pageYOffset || 0;
          var shouldFloat = currentScrollY > floatingStartY;
          mainControlsEl.classList.toggle('is-compact', currentScrollY > 90);
          mainControlsEl.classList.toggle('is-floating', shouldFloat);
          setAnnouncementCollapsed(shouldFloat);
          if (shouldFloat) syncFloatingGeometry();
        }

        function queueStickyUpdate() {
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function() {
            scrollRaf = null;
            applyStickyState();
          });
        }

        function handleResize() {
          if (resizeTimer) window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function() {
            recalculateStickyStart();
            applyStickyState();
          }, 80);
        }

        recalculateStickyStart();
        applyStickyState();

        window.addEventListener('scroll', queueStickyUpdate, { passive: true });
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        window.addEventListener('pagehide', function() {
          setAnnouncementCollapsed(false);
        });
      }

      function getActiveSortValue() {
        if (!sortSelect) return '';
        return sortSelect.value || defaultSortValue || '';
      }

      function syncSortChoiceState() {
        if (!sortSelect || !sortChoiceEls || sortChoiceEls.length === 0) return;
        var activeSortValue = getActiveSortValue();
        sortChoiceEls.forEach(function(choice) {
          var choiceValue = choice.getAttribute('data-sort-value') || '';
          var isActive = choiceValue === activeSortValue;
          choice.classList.toggle('is-active', isActive);
          choice.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function buildCollectionUrl(pageNumber, options) {
        var includeCriteria = !options || options.includeCriteria !== false;
        var requestUrl = new URL(window.location.href);
        requestUrl.searchParams.delete('page');
        if (pageNumber > 1) {
          requestUrl.searchParams.set('page', String(pageNumber));
        }

        var sortValue = getActiveSortValue();
        if (sortValue && sortValue !== defaultSortValue) {
          requestUrl.searchParams.set('sort_by', sortValue);
        } else {
          requestUrl.searchParams.delete('sort_by');
        }

        return normalizeCollectionRequestUrl(requestUrl.toString(), { includeCriteria: includeCriteria });
      }

      function normalizeCollectionRequestUrl(rawUrl, options) {
        var includeCriteria = !options || options.includeCriteria !== false;
        if (!rawUrl) return '';

        var requestUrl;
        var currentUrl;
        try {
          requestUrl = new URL(rawUrl, window.location.origin);
          currentUrl = new URL(window.location.href);
        } catch (error) {
          return rawUrl;
        }

        PREVIEW_QUERY_PARAMS.forEach(function(paramName) {
          if (!requestUrl.searchParams.has(paramName) && currentUrl.searchParams.has(paramName)) {
            requestUrl.searchParams.set(paramName, currentUrl.searchParams.get(paramName));
          }
        });

        var sortValue = getActiveSortValue();
        if (sortValue && sortValue !== defaultSortValue) {
          requestUrl.searchParams.set('sort_by', sortValue);
        } else {
          requestUrl.searchParams.delete('sort_by');
        }

        if (includeCriteria) applyServerCriteriaParams(requestUrl);

        return requestUrl.toString();
      }

      function syncBrowserUrlToSort() {
        if (!window.history || !window.history.replaceState) return;
        var requestUrl = new URL(window.location.href);
        requestUrl.searchParams.delete('page');
        if (serverColorFilterParamName) {
          requestUrl.searchParams.delete(serverColorFilterParamName);
        }
        requestUrl.searchParams.delete(SERVER_STOCK_FILTER_PARAM_NAME);

        var sortValue = getActiveSortValue();
        if (sortValue && sortValue !== defaultSortValue) {
          requestUrl.searchParams.set('sort_by', sortValue);
        } else {
          requestUrl.searchParams.delete('sort_by');
        }

        window.history.replaceState({ path: requestUrl.toString() }, '', requestUrl.pathname + requestUrl.search + requestUrl.hash);
      }

      function getTargetVisibleCount() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1024;
        if (viewportWidth <= 540) return 8;
        if (viewportWidth <= 989) return 10;
        return 12;
      }

      function getScrollPrefetchTarget() {
        return getTargetVisibleCount() + (mobileControlsMedia.matches ? 8 : 12);
      }

      function getSparseMatchThreshold() {
        return 8;
      }

      function shouldAutoContinueSparseSearch() {
        // Keep criteria loading explicit (manual load more / observer) to avoid
        // long auto-fetch chains after each filter interaction.
        return false;
      }

      function maybeContinueSparseSearch(requestCriteriaVersion) {
        if (requestCriteriaVersion !== criteriaVersion) return;
        if (!shouldAutoContinueSparseSearch()) {
          criteriaAutoContinueCount = 0;
          return;
        }
        if (loadingNextPage || loadingAllPagesPromise) return;
        if (criteriaAutoContinueCount >= MAX_CRITERIA_AUTO_CONTINUE_CYCLES) return;

        criteriaAutoContinueCount += 1;
        scheduleCriteriaPrefetch({
          targetVisible: getSparseMatchThreshold(),
          maxPages: 1,
          allowSparseAutoContinue: false
        });
      }

      function beginProductsUpdate(useOverlay) {
        if (!collectionRoot) return;
        collectionRoot.classList.add('hd-color-filter--loading');
        if (cardsContainer) cardsContainer.setAttribute('aria-busy', 'true');
        if (!useOverlay) return;
        collectionRoot.classList.add('hd-products-updating');
        if (updateTransitionTimer) {
          window.clearTimeout(updateTransitionTimer);
          updateTransitionTimer = null;
        }
      }

      function finishProductsUpdate(useOverlay) {
        if (!collectionRoot) return;
        collectionRoot.classList.remove('hd-color-filter--loading');
        if (cardsContainer) cardsContainer.setAttribute('aria-busy', 'false');
        if (!useOverlay) return;
        if (updateTransitionTimer) window.clearTimeout(updateTransitionTimer);
        updateTransitionTimer = window.setTimeout(function() {
          collectionRoot.classList.remove('hd-products-updating');
        }, 120);
      }

      function bumpCriteriaVersion() {
        criteriaVersion += 1;
        criteriaAutoContinueCount = 0;
        loadingAllPagesPromise = null;
        if (criteriaLoadTimer) {
          window.clearTimeout(criteriaLoadTimer);
          criteriaLoadTimer = null;
        }
      }

      function scheduleCriteriaPrefetch(options) {
        if (!hasActiveCriteria()) return;
        if (criteriaLoadTimer) window.clearTimeout(criteriaLoadTimer);
        var nextOptions = options || {};
        criteriaLoadTimer = window.setTimeout(function() {
          criteriaLoadTimer = null;
          loadRemainingPagesForActiveFilter(nextOptions);
        }, 90);
      }

      function refreshCards() {
        cards = Array.prototype.slice.call(cardsContainer.querySelectorAll('[data-hd-product-card]'));
        cards.forEach(function(card) {
          var cardColorKeys = readCardColorKeys(card);
          card._hdColorKeys = cardColorKeys;
          card._hdPrimaryColorKey = readCardPrimaryColorKey(card, cardColorKeys);
          card._hdSizeKeys = readCardSizeKeys(card);
          card._hdSearchText = readCardSearchText(card);
          card._hdAvailable = card.getAttribute('data-hd-available') !== 'false';
        });

        selectedColors.forEach(function(key) {
          if (!colorIndex[key]) selectedColors.delete(key);
        });
        if (selectedSizeKey && !isValidSizeSelectionKey(selectedSizeKey)) {
          selectedSizeKey = '';
        }
      }

      function applyFilterToCards() {
        var isGridLayout = cardsContainer.classList.contains('grid--uniform');
        var isFiltering = hasActiveCriteria();
        cardsContainer.classList.toggle('hd-color-filter-grid--active', isGridLayout && isFiltering);

        var visibleCount = 0;
        cards.forEach(function(card) {
          var showCard = hasSelectedColor(card._hdColorKeys || [], card._hdPrimaryColorKey)
            && cardMatchesSize(card._hdSizeKeys || [])
            && cardMatchesSearch(card._hdSearchText || '')
            && (!stockFilterActive || card._hdAvailable);
          card.style.display = showCard ? '' : 'none';
          card.classList.toggle('hd-color-filter__card--hidden', !showCard);
          card.setAttribute('aria-hidden', showCard ? 'false' : 'true');

          if (isGridLayout && isFiltering && showCard && selectedColors.size > 0) {
            var colorKeys = card._hdColorKeys || [];
            var primaryKey = card._hdPrimaryColorKey;

            if (selectedColors.size === 1) {
              // Single color: 4-tier sort
              //   -3 = card has ONLY this color (mono-color product — strongest signal)
              //   -2 = primary_color matches (explicit or implied) but card has other colors too
              //   -1 = selected color is first in filter_colors but not the primary
              //    0 = selected color appears as a secondary entry in filter_colors
              var selectedColor = null;
              selectedColors.forEach(function(k) { selectedColor = k; });

              var isMono = colorKeys.length === 1 && colorKeys[0] === selectedColor;
              if (isMono) {
                card.style.order = '-3';
              } else if (primaryKey === selectedColor) {
                card.style.order = '-2';
              } else if (colorKeys.length > 0 && colorKeys[0] === selectedColor) {
                card.style.order = '-1';
              } else {
                card.style.order = '0';
              }
            } else {
              // Multi-select (AND): all visible cards already have every selected color.
              // Sub-sort: cards whose primary_color is one of the selected colors rank higher.
              var hasPrimaryMatch = primaryKey && selectedColors.has(primaryKey);
              if (hasPrimaryMatch) {
                card.style.order = '-1';
              } else {
                card.style.order = '0';
              }
            }
          } else {
            card.style.order = '';
          }

          if (showCard) visibleCount += 1;
        });
        visibleProductCount = visibleCount;

        if (summaryEl) summaryEl.textContent = '';

        var hasFilterSelection = selectedColors.size > 0 || !!selectedSizeKey;
        if (utilityEl) {
          utilityEl.hidden = !hasFilterSelection;
          utilityEl.classList.toggle('is-active', hasFilterSelection);
        }

        if (resetEl) resetEl.hidden = selectedColors.size === 0 && !selectedSizeKey;
        if (selectedCountEl) {
          if (hasFilterSelection) {
            selectedCountEl.hidden = false;
            if (selectedColors.size > 0 && selectedSizeKey) {
              selectedCountEl.textContent = selectedColors.size + (selectedColors.size === 1 ? ' color + size selected' : ' colors + size selected');
            } else if (selectedColors.size > 0) {
              selectedCountEl.textContent = selectedColors.size + (selectedColors.size === 1 ? ' color selected' : ' colors selected');
            } else {
              selectedCountEl.textContent = 'Size selected';
            }
          } else {
            selectedCountEl.hidden = true;
            selectedCountEl.textContent = '';
          }
        }
        if (searchClearEl) searchClearEl.hidden = !searchQuery;
        if (emptyEl) emptyEl.hidden = visibleCount !== 0 || hasRemainingPages() || !hasActiveCriteria();

        updateDrawerButtons();
      }

      function computeLoadedColorCounts() {
        var cacheKey = criteriaVersion + '|' + cards.length + '|' + colorOrder.length;
        if (colorCountsCacheKey === cacheKey && colorCountsCache) return colorCountsCache;

        var counts = {};
        colorOrder.forEach(function(key) { counts[key] = 0; });

        cards.forEach(function(card) {
          if (!cardMatchesSearch(card._hdSearchText || '')) return;
          if (stockFilterActive && !card._hdAvailable) return;
          if (!cardMatchesSize(card._hdSizeKeys || [])) return;
          var cardKeys = card._hdColorKeys || [];

          cardKeys.forEach(function(key) {
            if (typeof counts[key] !== 'number') counts[key] = 0;
            if (selectedColors.size === 0 || selectedColors.has(key)) {
              // No filter active, or key is already selected: count normally
              counts[key] += 1;
            } else {
              // AND mode: only count if card passes all currently active selections
              var hasAllCurrent = true;
              selectedColors.forEach(function(selKey) {
                if (cardKeys.indexOf(selKey) === -1) hasAllCurrent = false;
              });
              if (hasAllCurrent) counts[key] += 1;
            }
          });
        });

        colorCountsCache = counts;
        colorCountsCacheKey = cacheKey;
        return counts;
      }

      function createSwatch(group) {
        var button = document.createElement('button');
        var isActive = selectedColors.has(group.key);
        var swatchTextColor = getSwatchTextColor(group.key);
        button.type = 'button';
        button.className = 'hd-color-filter__swatch' + (isActive ? ' is-active' : '');
        button.setAttribute('data-color-key', group.key);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-label', group.label + (isActive ? ' selected' : ''));
        button.style.background = group.swatch;
        button.style.color = swatchTextColor;
        button.style.setProperty('--hd-swatch-indicator-color', swatchTextColor);
        if (isActive) {
          button.style.borderColor = '#2f1f45';
        }

        var checkEl = document.createElement('span');
        checkEl.className = 'hd-color-filter__swatch-check';
        checkEl.setAttribute('aria-hidden', 'true');
        checkEl.textContent = '\u2713';
        button.appendChild(checkEl);

        var labelEl = document.createElement('span');
        labelEl.className = 'hd-color-filter__swatch-label';
        labelEl.textContent = group.label;
        button.appendChild(labelEl);

        return button;
      }

      function createSizeOptionButton(option) {
        var button = document.createElement('button');
        var isActive = option.key === selectedSizeKey || (option.key === '' && !selectedSizeKey);
        button.type = 'button';
        button.className = 'hd-size-filter__option' + (isActive ? ' is-active' : '');
        button.setAttribute('data-size-key', option.key);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-label', option.label + (isActive ? ' selected' : ''));
        button.setAttribute('role', 'listitem');

        var checkEl = document.createElement('span');
        checkEl.className = 'hd-size-filter__check';
        checkEl.setAttribute('aria-hidden', 'true');
        checkEl.textContent = '\u2713';
        button.appendChild(checkEl);

        var labelEl = document.createElement('span');
        labelEl.className = 'hd-size-filter__option-label';
        labelEl.textContent = option.label;
        button.appendChild(labelEl);

        return button;
      }

      function renderSizeOptions() {
        if (!sizeOptionsEl) return;
        sizeOptionsEl.innerHTML = '';
        SIZE_FILTER_OPTIONS.forEach(function(option) {
          sizeOptionsEl.appendChild(createSizeOptionButton(option));
        });
      }

      function renderSwatches() {
        var counts = computeLoadedColorCounts();
        swatchesEl.innerHTML = '';

        colorOrder.forEach(function(key) {
          var group = colorIndex[key];
          if (!group) return;
          // Keep the primary color choices visible from first paint; avoids
          // "new colors appear only after first click/scroll" behavior.
          if (group.key.indexOf('custom-') === 0) {
            var count = counts[group.key] || 0;
            if (count === 0 && !selectedColors.has(group.key)) return;
          }
          swatchesEl.appendChild(createSwatch(group));
        });
      }

      function renderFilter() {
        renderSwatches();
        renderSizeOptions();
        applyFilterToCards();
        updatePaginationUi();
        scheduleQuickAddWarmup();
      }

      function renderFilterAnimated() {
        // Cancel any in-flight animation and snap to clean state
        if (filterAnimTimer) {
          clearTimeout(filterAnimTimer);
          filterAnimTimer = null;
          cardsContainer.classList.remove('hd-filter-applying');
          hideFilterSpinner();
          void cardsContainer.offsetHeight; // force reflow so transition fires cleanly on restart
        }

        // Apply filter immediately so visibleProductCount is accurate for
        // page-loading decisions; cards are invisible (opacity 0) so the
        // user never sees the wrong set.
        renderSwatches();
        renderSizeOptions();
        applyFilterToCards();
        updatePaginationUi();

        // Fade out + show spinner over grid
        var spinnerMessage = preloadPromise ? buildPreloadSpinnerMessage() : 'Applying filters...';
        cardsContainer.classList.add('hd-filter-applying');
        showFilterSpinner(spinnerMessage);

        var animVersion = criteriaVersion;

        function completeAnimation() {
          if (animVersion !== criteriaVersion) return; // stale — a newer click took over
          setFilterSpinnerMessage('Sorting matching products...');
          applyFilterToCards();
          updatePaginationUi();
          cardsContainer.classList.remove('hd-filter-applying'); // triggers fade-in
          filterAnimTimer = setTimeout(function() {
            if (animVersion !== criteriaVersion) return;
            hideFilterSpinner();
            filterAnimTimer = null;
          }, 160);
        }

        // If parallel preload is still running, wait for it; otherwise animate now
        if (preloadPromise) {
          preloadPromise.then(completeAnimation);
        } else {
          filterAnimTimer = setTimeout(completeAnimation, 160);
        }
      }

      function fetchCollectionDocument(url) {
        var abortController = typeof window.AbortController === 'function' ? new window.AbortController() : null;
        var timeoutId = null;
        var requestOptions = { credentials: 'same-origin' };
        if (abortController) {
          requestOptions.signal = abortController.signal;
          timeoutId = window.setTimeout(function() {
            abortController.abort();
          }, COLLECTION_FETCH_TIMEOUT_MS);
        }

        return fetch(url, requestOptions)
          .then(function(response) {
            if (!response.ok) throw new Error('Failed to fetch ' + url);
            return response.text();
          })
          .then(function(html) {
            return new window.DOMParser().parseFromString(html, 'text/html');
          })
          .then(function(doc) {
            if (timeoutId) window.clearTimeout(timeoutId);
            return doc;
          }, function(error) {
            if (timeoutId) window.clearTimeout(timeoutId);
            throw error;
          });
      }

      function getNextPageUrlFromDocument(doc) {
        if (!doc) return '';
        var nextLink = doc.querySelector('#AjaxinatePagination a[href]');
        return nextLink ? normalizeCollectionRequestUrl(nextLink.href) : '';
      }

      // One product per card: the product id when the card carries one, else its /products/ link.
      function getCardProductKey(card) {
        if (!card) return '';
        if (typeof card._hdProductKey === 'string') return card._hdProductKey;
        var key = '';
        var idEl = card.querySelector ? card.querySelector('[data-hd-product-id]') : null;
        var productId = idEl ? String(idEl.getAttribute('data-hd-product-id') || '').trim() : '';
        if (productId && productId !== '0') {
          key = 'id:' + productId;
        } else {
          var link = card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
          var href = link ? String(link.getAttribute('href') || '') : '';
          var productIndex = href.indexOf('/products/');
          if (productIndex !== -1) key = 'url:' + href.slice(productIndex).split(/[?#]/)[0];
        }
        card._hdProductKey = key;
        return key;
      }

      function appendCardsFromDocument(doc) {
        var newCards = Array.prototype.slice.call(doc.querySelectorAll('#AjaxinateLoop [data-hd-product-card]'));
        if (newCards.length === 0) {
          newCards = Array.prototype.slice.call(doc.querySelectorAll('[data-hd-product-card]'));
        }
        if (newCards.length === 0) return;

        // The same page can arrive twice (a criteria fetch and the parallel preload race when a colour or search is active
        // early, e.g. restored on arrival); keep the first copy of each product. Built from `cards`, so it resets with it.
        var knownProductKeys = {};
        cards.forEach(function(existingCard) {
          var existingKey = getCardProductKey(existingCard);
          if (existingKey) knownProductKeys[existingKey] = true;
        });

        var fragment = document.createDocumentFragment();
        newCards.forEach(function(card) {
          var productKey = getCardProductKey(card);
          if (productKey && knownProductKeys[productKey]) return;
          if (productKey) knownProductKeys[productKey] = true;

          var cardColorKeys = readCardColorKeys(card);
          card._hdColorKeys = cardColorKeys;
          card._hdPrimaryColorKey = readCardPrimaryColorKey(card, cardColorKeys);
          card._hdSizeKeys = readCardSizeKeys(card);
          card._hdSearchText = readCardSearchText(card);
          card._hdAvailable = card.getAttribute('data-hd-available') !== 'false';

          // Apply current filter state immediately so cards don't flash
          if (hasActiveCriteria()) {
            var show = hasSelectedColor(card._hdColorKeys, card._hdPrimaryColorKey)
                    && cardMatchesSize(card._hdSizeKeys || [])
                    && cardMatchesSearch(card._hdSearchText || '')
                    && (!stockFilterActive || card._hdAvailable);
            if (!show) {
              card.style.display = 'none';
              card.classList.add('hd-color-filter__card--hidden');
              card.setAttribute('aria-hidden', 'true');
            }
          }

          fragment.appendChild(card);
          cards.push(card);
        });
        cardsContainer.appendChild(fragment);
        scheduleQuickAddWarmup();
      }

      function updatePaginationUi() {
        if (!paginationEl) return;
        if (!nextPageUrl) {
          paginationEl.style.display = 'none';
          return;
        }

        paginationEl.style.display = '';
        var link = paginationEl.querySelector('a');
        if (!link) {
          link = document.createElement('a');
          paginationEl.appendChild(link);
        }
        link.href = nextPageUrl;
        if (hasActiveCriteria()) {
          var autoSearchingSparseMatches = shouldAutoContinueSparseSearch();
          if (loadingNextPage || autoSearchingSparseMatches) {
            paginationEl.style.display = 'none';
            link.textContent = '';
            link.setAttribute('aria-disabled', 'true');
            link.style.pointerEvents = 'none';
            link.style.opacity = '0.8';
          } else {
            paginationEl.style.display = '';
            link.textContent = 'Load more matching products';
            link.removeAttribute('aria-disabled');
            link.style.pointerEvents = '';
            link.style.opacity = '';
          }
        } else {
          paginationEl.style.display = '';
          link.textContent = loadingNextPage ? 'Loading more products...' : 'Loading More';
          link.removeAttribute('aria-disabled');
          link.style.pointerEvents = '';
          link.style.opacity = '';
        }
      }

      function loadNextPage() {
        if (loadingNextPage || !nextPageUrl) return Promise.resolve(false);

        var requestUrl = normalizeCollectionRequestUrl(nextPageUrl);
        if (!requestUrl) {
          nextPageUrl = '';
          updatePaginationUi();
          return Promise.resolve(false);
        }
        nextPageUrl = requestUrl;
        var requestVersion = collectionVersion;
        if (loadedPageUrls[requestUrl]) {
          // Guard against accidental loops if the same next-page URL repeats.
          nextPageUrl = '';
          updatePaginationUi();
          return Promise.resolve(false);
        }

        loadingNextPage = true;
        beginProductsUpdate(false);
        updatePaginationUi();

        return fetchCollectionDocument(requestUrl)
          .then(function(doc) {
            if (requestVersion !== collectionVersion) return false;
            appendCardsFromDocument(doc);
            loadedPageUrls[requestUrl] = true;
            delete pageLoadRetryCounts[requestUrl];
            nextPageUrl = getNextPageUrlFromDocument(doc);
            return true;
          })
          .catch(function() {
            if (requestVersion !== collectionVersion) return false;
            var retryCount = (pageLoadRetryCounts[requestUrl] || 0) + 1;
            pageLoadRetryCounts[requestUrl] = retryCount;
            if (retryCount > MAX_PAGE_FETCH_RETRIES) {
              nextPageUrl = '';
            } else {
              // Keep URL so a transient storefront fetch error can recover.
              nextPageUrl = requestUrl;
            }
            return false;
          })
          .then(function(didLoadPage) {
            if (requestVersion !== collectionVersion) return false;
            loadingNextPage = false;
            finishProductsUpdate(false);
            renderFilter();
            return didLoadPage;
          }, function() {
            if (requestVersion !== collectionVersion) return false;
            loadingNextPage = false;
            finishProductsUpdate(false);
            renderFilter();
            return false;
          });
      }

      function loadRemainingPagesForActiveFilter(options) {
        if (!hasActiveCriteria() || !nextPageUrl) return Promise.resolve();
        if (loadingAllPagesPromise) return loadingAllPagesPromise;
        var requestCriteriaVersion = criteriaVersion;
        var targetVisible = Math.max(getTargetVisibleCount(), (options && options.targetVisible) || 0);
        var maxPages = Math.max(1, (options && options.maxPages) || 1);
        var allowSparseAutoContinue = !options || options.allowSparseAutoContinue !== false;
        if (visibleProductCount >= targetVisible) return Promise.resolve();

        var pagesLoaded = 0;

        var keepLoading = function() {
          if (requestCriteriaVersion !== criteriaVersion) return Promise.resolve();
          if (!hasActiveCriteria() || !nextPageUrl) return Promise.resolve();
          if (visibleProductCount >= targetVisible) return Promise.resolve();
          if (pagesLoaded >= maxPages) return Promise.resolve();
          pagesLoaded += 1;
          return loadNextPage().then(function(didLoadPage) {
            if (!didLoadPage) return;
            return keepLoading();
          });
        };

        loadingAllPagesPromise = keepLoading().then(function() {
          loadingAllPagesPromise = null;
          renderFilter();
          if (allowSparseAutoContinue) maybeContinueSparseSearch(requestCriteriaVersion);
        }, function() {
          loadingAllPagesPromise = null;
          renderFilter();
          if (allowSparseAutoContinue) maybeContinueSparseSearch(requestCriteriaVersion);
        });

        return loadingAllPagesPromise;
      }

      function setupObserver() {
        if (!paginationEl || !window.IntersectionObserver) return;
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            if (hasActiveCriteria()) {
              loadRemainingPagesForActiveFilter({
                targetVisible: Math.max(getScrollPrefetchTarget(), visibleProductCount + 8),
                maxPages: 1
              });
            } else {
              loadNextPage();
            }
          });
        }, { rootMargin: '900px 0px' });

        observer.observe(paginationEl);
      }

      function replaceCardsForCurrentSort() {
        collectionVersion += 1;
        var requestVersion = collectionVersion;
        var firstPageUrl = buildCollectionUrl(1, { includeCriteria: false });
        var previousNextPageUrl = nextPageUrl;
        var previousLoadedPageUrls = Object.assign({}, loadedPageUrls);
        var previousPageLoadRetryCounts = Object.assign({}, pageLoadRetryCounts);
        criteriaAutoContinueCount = 0;

        syncSortChoiceState();
        loadingAllPagesPromise = null;
        if (criteriaLoadTimer) {
          window.clearTimeout(criteriaLoadTimer);
          criteriaLoadTimer = null;
        }
        loadingNextPage = false;
        nextPageUrl = '';
        loadedPageUrls = {};
        pageLoadRetryCounts = {};
        beginProductsUpdate(true);
        renderFilter();

        return fetchCollectionDocument(firstPageUrl)
          .then(function(doc) {
            if (requestVersion !== collectionVersion) return;
            cards = [];
            cardsContainer.innerHTML = '';
            appendCardsFromDocument(doc);
            nextPageUrl = getNextPageUrlFromDocument(doc);
            loadedPageUrls[firstPageUrl] = true;
            syncBrowserUrlToSort();
            renderFilter();
            var preloadWaitPromise = preloadAllPagesParallel();
            if (hasActiveCriteria()) renderFilterAnimated();

            return preloadWaitPromise.then(function() {
              if (requestVersion !== collectionVersion) return;
              finishProductsUpdate(true);
              renderFilter();
              saveCollectionState();
            }, function() {
              if (requestVersion !== collectionVersion) return;
              finishProductsUpdate(true);
              renderFilter();
              saveCollectionState();
            });
          })
          .catch(function() {
            if (requestVersion !== collectionVersion) return;
            nextPageUrl = previousNextPageUrl;
            loadedPageUrls = previousLoadedPageUrls;
            pageLoadRetryCounts = previousPageLoadRetryCounts;
            syncBrowserUrlToSort();
            finishProductsUpdate(true);
            renderFilter();
            saveCollectionState();
          });
      }

      function setupSortHandling() {
        if (!sortSelect) return;
        syncSortChoiceState();

        sortChoiceEls.forEach(function(choice) {
          choice.addEventListener('click', function(event) {
            event.preventDefault();
            var nextSortValue = choice.getAttribute('data-sort-value') || '';
            if (!nextSortValue || nextSortValue === getActiveSortValue()) {
              syncSortChoiceState();
              return;
            }
            sortSelect.value = nextSortValue;
            syncSortChoiceState();
            replaceCardsForCurrentSort();
          });
        });

        sortSelect.addEventListener('change', function(event) {
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          event.stopPropagation();
          syncSortChoiceState();
          replaceCardsForCurrentSort();
        }, true);
      }

      function setupSearchHandling() {
        if (!searchInputEl) return;

        var searchDebounceTimer = null;
        var updateSearch = function(rawValue) {
          var nextLabel = String(rawValue || '').replace(/\s+/g, ' ').trim();
          var nextQuery = normalizeText(nextLabel);
          if (nextLabel === searchQueryLabel && nextQuery === searchQuery) return;
          searchQueryLabel = nextLabel;
          searchQuery = nextQuery;
          searchTerms = nextQuery ? nextQuery.split(' ').filter(Boolean) : [];
          bumpCriteriaVersion();
          renderFilter();
          scheduleCriteriaPrefetch({
            targetVisible: getTargetVisibleCount(),
            maxPages: 1
          });
          saveCollectionState();
        };

        searchInputEl.addEventListener('input', function() {
          var nextValue = this.value || '';
          if (searchDebounceTimer) window.clearTimeout(searchDebounceTimer);
          searchDebounceTimer = window.setTimeout(function() {
            updateSearch(nextValue);
          }, 140);
        });

        if (searchClearEl) {
          searchClearEl.addEventListener('click', function() {
            searchInputEl.value = '';
            updateSearch('');
            searchInputEl.focus();
          });
        }
      }

      resetEl.addEventListener('click', function() {
        selectedColors.clear();
        selectedSizeKey = '';
        bumpCriteriaVersion();
        loadingAllPagesPromise = null;
        if (criteriaLoadTimer) {
          window.clearTimeout(criteriaLoadTimer);
          criteriaLoadTimer = null;
        }
        preloadAllPagesParallel();
        renderFilterAnimated();
        saveCollectionState();
      });

      if (toggleEl) {
        toggleEl.addEventListener('click', function() {
          var isCollapsed = filterRoot.classList.contains('is-collapsed');
          setCollapsed(!isCollapsed, true);
        });
      }

      if (browseToggleEl) {
        browseToggleEl.addEventListener('click', function() {
          var isCollapsed = browsePanelEl && browsePanelEl.classList.contains('is-collapsed');
          setBrowseCollapsed(!isCollapsed, true);
        });
      }

      if (paginationEl) {
        paginationEl.addEventListener('click', function(event) {
          var target = event.target;
          while (target && target !== paginationEl && target.tagName !== 'A') {
            target = target.parentNode;
          }
          if (!target || target.tagName !== 'A') return;

          event.preventDefault();
          if (hasActiveCriteria()) {
            loadRemainingPagesForActiveFilter({
              targetVisible: Math.max(getScrollPrefetchTarget(), visibleProductCount + 8),
              maxPages: 1
            });
          } else {
            loadNextPage();
          }
        });
      }

      function preloadAllPagesParallel() {
        if (preloadPromise) return preloadPromise;
        if (totalCollectionPages <= 1) return Promise.resolve();

        var preloadVersion = collectionVersion;
        var pageQueue = [];
        for (var pageNumber = 2; pageNumber <= totalCollectionPages; pageNumber += 1) {
          pageQueue.push(pageNumber);
        }

        if (pageQueue.length === 0) return Promise.resolve();
        var pageResults = {};
        preloadProgressTotal = pageQueue.length;
        preloadProgressLoaded = 0;
        preloadProgressFailed = 0;
        updatePreloadProgressMessage();

        function fetchCollectionDocumentWithRetries(url, retriesLeft) {
          return fetchCollectionDocument(url).catch(function(error) {
            if (retriesLeft <= 0) throw error;
            return fetchCollectionDocumentWithRetries(url, retriesLeft - 1);
          });
        }

        function loadOnePage(pageNumber) {
          if (preloadVersion !== collectionVersion) return Promise.resolve();
          var url = buildCollectionUrl(pageNumber, { includeCriteria: false });
          if (loadedPageUrls[url]) {
            preloadProgressLoaded += 1;
            updatePreloadProgressMessage();
            return Promise.resolve();
          }

          return fetchCollectionDocumentWithRetries(url, PRELOAD_PAGE_MAX_RETRIES)
            .then(function(doc) {
              if (preloadVersion !== collectionVersion) return;
              pageResults[pageNumber] = doc;
              loadedPageUrls[url] = true;
              preloadProgressLoaded += 1;
              updatePreloadProgressMessage();
            });
        }

        function worker() {
          if (preloadVersion !== collectionVersion) return Promise.resolve();
          var nextPageNumber = pageQueue.shift();
          if (typeof nextPageNumber === 'undefined') return Promise.resolve();
          return loadOnePage(nextPageNumber)
            .catch(function() {
              preloadProgressFailed += 1;
              updatePreloadProgressMessage();
              return;
            })
            .then(worker);
        }

        var workers = [];
        var workerCount = Math.max(1, Math.min(resolvePreloadBatchSize(), pageQueue.length));
        for (var i = 0; i < workerCount; i += 1) {
          workers.push(worker());
        }

        preloadPromise = Promise.all(workers).then(function() {
          if (preloadVersion !== collectionVersion) return;
          // Append pages in correct order (parallel fetch may resolve out of order)
          for (var p = 2; p <= totalCollectionPages; p++) {
            if (pageResults[p]) appendCardsFromDocument(pageResults[p]);
          }
          nextPageUrl = '';
          if (filterSpinnerEl && filterSpinnerEl.classList.contains('is-active')) {
            setFilterSpinnerMessage('Finalizing product order...');
          }
          preloadPromise = null;
          renderFilter();
        }, function() {
          preloadPromise = null;
        });

        return preloadPromise;
      }

      swatchesEl.addEventListener('click', function(e) {
        var button = e.target.closest('.hd-color-filter__swatch');
        if (!button) return;
        var key = button.getAttribute('data-color-key');
        if (!key || !colorIndex[key]) return;
        if (selectedColors.has(key)) selectedColors.delete(key);
        else selectedColors.add(key);
        bumpCriteriaVersion();
        preloadAllPagesParallel();
        renderFilterAnimated();
        saveCollectionState();
      });

      if (sizeOptionsEl) {
        sizeOptionsEl.addEventListener('click', function(e) {
          var button = e.target.closest('.hd-size-filter__option');
          if (!button) return;
          var nextKey = String(button.getAttribute('data-size-key') || '');
          if (!isValidSizeSelectionKey(nextKey)) return;
          if (selectedSizeKey === nextKey) return;
          selectedSizeKey = nextKey;
          bumpCriteriaVersion();
          preloadAllPagesParallel();
          renderFilterAnimated();
          saveCollectionState();
        });
      }

      initializeCollapsedState();
      initializeBrowseCollapsedState();
      setupStickyCartSync();
      setupCartDrawer();
      setupQuickAddModal();
      setupMainControls();
      setupMainControlsStickyState();
      setupSortHandling();
      setupSearchHandling();
      refreshCards();
      renderFilter();
      setDrawerOpenState('');
      updateDrawerButtons();
      setupCollectionStatePersistence();
      setupLeagueNavCarryOver();
      restoreCollectionStateIfNeeded();
      setupObserver();
      preloadAllPagesParallel();
    })();
